import React, { useState, useEffect, useRef } from "react";
import {
  deleteEmployeeTrainingVideo,
  deleteEmployee,
  updateEmployee,
  useEmployeeDetails,
  getImageFileUrl,
  createEmployee,
  EmployeeForm,
  Designation,
  useDesignationList,
  deleteTeam,
  useTeamDetails,
  createTeam,
  updateTeam,
  useTeamsList,
  TeamList,
  Teams,
  EmployeeType,
  Employees,
  useRolesList,
  useAssigneeList,
  Roles,
  useEmployeeList,
  TeamForm,
  updateTrainingVideo,
  useEmployeeNumber,
} from "./api";
import { Dropdown } from "primereact/dropdown";
import assigneeImg from "../../assets/images/assignee.png";
import DataLoading from "../../components/DataLoading";
import { Dialog } from "primereact/dialog";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { AssigneeType } from "../Task/api";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import "primereact/resources/themes/saga-green/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { dateBeautify } from "../../helpers/utils";
import { hasPermission } from "../../helpers/common";
import { getPermissionsList, getRolesList } from "../../helpers/getPermission";
import { confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import defaultpicture from "../../assets/images/image-defaultpicture.png";
import DefaultImage from "../../profile_images/DefaultImage";

type TeamsItemProps = Teams & {
  selectedTeamName: React.Dispatch<React.SetStateAction<string>>;
  selectedTeam: React.Dispatch<React.SetStateAction<string>>;
  teamId: string | undefined;
  setSortedName: React.Dispatch<React.SetStateAction<string>>;
  setRolesData: React.Dispatch<React.SetStateAction<string>>;
  teamMutate: any;
  employeeListMutate: any;
  setSelectedReportingPerson: React.Dispatch<React.SetStateAction<string>>;
  manager: { _id: string; name: string; profilepic: string };
};

const TeamSidePanel = ({
  teamsList,
  isLoading,
  selectedTeam,
  selectedTeamName,
  employeeListMutate,
  teamMutate,
  permissions,
  setSortedName,
  setRolesData,
  setIsTeamUpdate,
  setTeamFields,
  teamId,
  setshowTeamModal,
  setSelectedReportingPerson,
}: {
  teamsList: TeamList[] | undefined;
  isLoading: boolean;
  selectedTeam: React.Dispatch<React.SetStateAction<string>>;
  selectedTeamName: React.Dispatch<React.SetStateAction<string>>;
  teamId: string | undefined;
  setshowTeamModal: React.Dispatch<React.SetStateAction<boolean>>;
  setIsTeamUpdate: React.Dispatch<React.SetStateAction<boolean>>;
  setTeamFields: React.Dispatch<React.SetStateAction<TeamForm>>;
  permissions: string[];
  setSortedName: React.Dispatch<React.SetStateAction<string>>;
  setRolesData: React.Dispatch<React.SetStateAction<string>>;
  teamMutate: any;
  employeeListMutate: any;
  setSelectedReportingPerson: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const [toggleNav, setToggleNav] = useState("open");
  const openNav = () =>
    setToggleNav((state) => (state === "open" ? "close" : "open"));

  if (isLoading) {
    return <DataLoading />;
  }

  let teams;

  if (teamsList) {
    teams = [
      {
        _id: "All",
        name: "All",
        manager: { _id: "All", name: "All", profilepic: "" },
      },
      ...teamsList,
    ];
  }

  // Sort the teams array alphabetically by name (ascending)
  const sortedTeams = teams
    ? [...teams].sort((a, b) => a.name.localeCompare(b.name))
    : [];

  return (
    <div className="collapse-box-wrap">
      <div className={`collapse-box team-theme ${toggleNav}`}>
        <div className="d-flex col-head pb-0">
          <div className="d-flex title-action">
            <p>Teams List</p>
            {hasPermission(permissions, ["departments:write"]) && (
              <button
                className="d-flex icon-button"
                type="button"
                data-bs-toggle="modal"
                onClick={() =>
                  openCreateTeam(
                    setshowTeamModal,
                    setIsTeamUpdate,
                    setTeamFields
                  )
                }
              >
                <span className="material-icons-round">add</span>
              </button>
            )}
          </div>
          <button onClick={openNav}>
            <span className="material-icons-round">keyboard_arrow_left</span>
          </button>
        </div>
        <div className="col-body">
          <div className="col-bd-ele">
            {sortedTeams?.map((item) => (
              <TeamsItem
                key={item._id}
                _id={item._id}
                name={item.name}
                manager={item.manager}
                employeeListMutate={employeeListMutate}
                teamMutate={teamMutate}
                setSortedName={setSortedName}
                setRolesData={setRolesData}
                selectedTeam={selectedTeam}
                selectedTeamName={selectedTeamName}
                teamId={teamId}
                setSelectedReportingPerson={setSelectedReportingPerson}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const openCreateTeam = (
  setshowTeamModal: React.Dispatch<React.SetStateAction<boolean>>,
  setIsTeamUpdate: React.Dispatch<React.SetStateAction<boolean>>,
  setTeamFields: React.Dispatch<React.SetStateAction<TeamForm>>
) => {
  setIsTeamUpdate(false);
  let teamForm: TeamForm = {
    _id: "",
    name: "",
    manager: null,
    description: null,
    work_schedule: null,
  };
  setTeamFields(teamForm);
  setshowTeamModal(true);
};

const TeamsItem: React.FC<TeamsItemProps> = ({
  _id,
  name,
  manager,
  selectedTeam,
  teamMutate,
  employeeListMutate,
  selectedTeamName,
  setSortedName,
  setRolesData,
  teamId,
  setSelectedReportingPerson,
}) => {
  const handleClick = (_id: string) => {
    selectedTeam(_id);
    setSelectedReportingPerson(manager?._id);
    selectedTeamName(name);
    setSortedName("asce");
    setRolesData("All");
    employeeListMutate();
    teamMutate();
  };

  return (
    <div
      className={`d-flex task-name ${_id === teamId ? "clicked" : ""}`}
      onClick={() => handleClick(_id)}
    >
      <div className="d-flex">
        <span className="material-icons-outlined">people</span>
        <p>{name}</p>
      </div>
      <div className="arr-ryt">
        <span className="material-icons-round">keyboard_arrow_right</span>
      </div>
    </div>
  );
};

const EmployeeTableList = ({
  rolesList,
  selectedTeam,
  employeeListMutate,
  selectSortName,
  isEmployeesLoading,
  employeesList,
  enableSidePanel,
  selectedTeamName,
  setshowTeamModal,
  setEmployeeSortList,
  totalMembers,
  setSortedName,
  setTotalMembers,
  rolesData,
  setRolesData,
  setIsTeamUpdate,
  setEmployeeModal,
  teamDetails,
  setTeamFields,
  selectedEmployee,
  setSelectedEmployee,
  permissions,
  employeeDetails,
  myToast,
}: {
  rolesList: Roles[] | undefined;
  selectSortName: string;
  setSortedName: React.Dispatch<React.SetStateAction<string>>;
  rolesData: string;
  selectedTeamName: string | undefined;
  setRolesData: React.Dispatch<React.SetStateAction<string>>;
  employeesList: Employees[] | undefined;
  totalMembers: number;
  setTotalMembers: React.Dispatch<React.SetStateAction<number>>;
  setEmployeeSortList: React.Dispatch<
    React.SetStateAction<Employees[] | undefined>
  >;
  setIsTeamUpdate: React.Dispatch<React.SetStateAction<boolean>>;
  setshowTeamModal: React.Dispatch<React.SetStateAction<boolean>>;
  setEmployeeModal: React.Dispatch<React.SetStateAction<boolean>>;
  employeeListMutate: any;
  teamDetails: TeamList | undefined;
  setTeamFields: React.Dispatch<React.SetStateAction<TeamForm>>;
  enableSidePanel: React.Dispatch<React.SetStateAction<boolean>>;
  selectedTeam: string;
  selectedEmployee: string;
  setSelectedEmployee: React.Dispatch<React.SetStateAction<string>>;
  isEmployeesLoading: boolean;
  permissions: string[];
  employeeDetails: EmployeeType | undefined;
  myToast: any;
}) => {
  let roleItems;

  if (rolesList) {
    roleItems = [{ _id: "All", role_name: "Roles" }, ...rolesList];
    // roleItems = [{ _id: 'All', }, ...rolesList]
  }

  useEffect(() => {
    if (employeesList) {
      setTotalMembers(employeesList?.length);
      // setSelectedEmployee(selectedTeamName)
    }
  }, [employeesList, setTotalMembers]);

  return (
    <div className="task-top-table-separate team-theme">
      <div className="mn-dtls-vw container">
        <div className="d-flex dtls-top-sec">
          <div className="d-flex task-nm-dtls">
            <p>{selectedTeamName} </p>
          </div>
          <div className="d-flex task-dp-dtls">
            <div className="d-flex tsk-counts">
              <div className="d-flex">
                <p>{totalMembers} Members</p>
              </div>
            </div>

            <div className="tsk-btn team-btn d-flex">
              {selectedTeam !== "All" ? (
                <>
                  {hasPermission(permissions, ["departments:write"]) && (
                    <button
                      className="d-flex outline-button"
                      type="button"
                      onClick={() =>
                        setUpdateTeamModal({
                          setIsTeamUpdate,
                          setshowTeamModal,
                          teamDetails,
                          setTeamFields,
                        })
                      }
                    >
                      <span className="material-icons-outlined">edit</span>
                      <p>Edit</p>
                    </button>
                  )}
                  {hasPermission(permissions, ["people:write"]) && (
                    <button
                      className="d-flex"
                      type="button"
                      data-bs-toggle="modal"
                      onClick={() => setEmployeeModal(true)}
                    >
                      <span className="material-icons-round">add</span>
                      <p>Member</p>
                    </button>
                  )}{" "}
                </>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        <div className="dtls-mn-sec">
          <div className="d-flex tsk-filter-sec">
            <div className="d-flex filter-lft">
              <div className="d-flex drpdwn-slct status-slct">
                <span className="material-icons-outlined">filter_alt</span>
                <Dropdown
                  name="roleId"
                  optionLabel="role_name"
                  optionValue="_id"
                  value={rolesData}
                  onChange={(e) => setRolesData(e.target.value)}
                  options={rolesList}
                  placeholder="Select"
                />
              </div>
            </div>

            <SortEmployeesByName
              employeesList={employeesList}
              setEmployeeSortList={setEmployeeSortList}
              selectSortName={selectSortName}
              setSortedName={setSortedName}
            />
          </div>
        </div>
      </div>

      {employeesList ? (
        <EmployeeDataList
          isEmployeesLoading={isEmployeesLoading}
          employeesList={employeesList}
          employeeListMutate={employeeListMutate}
          enableSidePanel={enableSidePanel}
          selectedEmployee={selectedEmployee}
          setSelectedEmployee={setSelectedEmployee}
          employeeDetails={employeeDetails}
          selectedTeam={selectedTeam}
          myToast={myToast}
          permissions={permissions}
        />
      ) : null}
    </div>
  );
};

const setUpdateTeamModal = ({
  setIsTeamUpdate,
  setshowTeamModal,
  teamDetails,
  setTeamFields,
}: {
  setIsTeamUpdate: React.Dispatch<React.SetStateAction<boolean>>;
  setshowTeamModal: React.Dispatch<React.SetStateAction<boolean>>;
  teamDetails: TeamList | undefined;
  setTeamFields: React.Dispatch<React.SetStateAction<TeamForm>>;
}) => {
  setIsTeamUpdate(true);
  if (teamDetails) {
    let teamForm: TeamForm = {
      _id: teamDetails._id,
      name: teamDetails.name,
      manager: teamDetails.manager?._id,
      description: teamDetails.description,
      work_schedule: teamDetails.work_schedule,
    };
    setTeamFields(teamForm);
  }
  setshowTeamModal(true);
};

const SortEmployeesByName = ({
  selectSortName,
  employeesList,
  setSortedName,
  setEmployeeSortList,
}: {
  selectSortName: string;
  employeesList: Employees[] | undefined;
  setSortedName: React.Dispatch<React.SetStateAction<string>>;
  setEmployeeSortList: React.Dispatch<
    React.SetStateAction<Employees[] | undefined>
  >;
}) => {
  const sortedOptions = [
    // {label: 'Sort', value:'Sort'},
    { label: "Name (A to Z)", value: "asce" },
    { label: "Name (Z to A)", value: "dsce" },
  ];
  return (
    <div className="d-flex filter-ryt">
      <div className="d-flex drpdwn-slct">
        <span className="material-icons-round">sort</span>
        <Dropdown
          name="sort"
          optionLabel="label"
          optionValue="value"
          value={selectSortName}
          onChange={(e) => {
            setSortedName(e.target.value);

            if (employeesList) {
              if (selectSortName === "asce") {
                let data = employeesList;
                const sortedItems = data.sort((a, b) => {
                  return a.name.trim().toLowerCase() <
                    b.name.trim().toLowerCase()
                    ? 1
                    : -1;
                });
                setEmployeeSortList([...sortedItems]);
              } else {
                let data = employeesList;
                const sortedItems = data.sort((a, b) => {
                  return a.name.trim().toLowerCase() >
                    b.name.trim().toLowerCase()
                    ? 1
                    : -1;
                });
                setEmployeeSortList([...sortedItems]);
              }
            }
          }}
          options={sortedOptions}
          // placeholder="Select"
        />
      </div>
    </div>
  );
};

const EmployeeDataList = ({
  isEmployeesLoading,
  employeesList,
  employeeListMutate,
  enableSidePanel,
  selectedEmployee,
  setSelectedEmployee,
  employeeDetails,
  selectedTeam,
  myToast,
  permissions,
}: {
  isEmployeesLoading: boolean;
  employeeListMutate: any;
  employeesList: Employees[] | undefined;
  enableSidePanel: React.Dispatch<React.SetStateAction<boolean>>;
  selectedEmployee: string;
  setSelectedEmployee: React.Dispatch<React.SetStateAction<string>>;
  employeeDetails: EmployeeType | undefined;
  selectedTeam: string;
  myToast: any;
  permissions: string[];
}) => {
  if (isEmployeesLoading) {
    return <DataLoading />;
  }
  return (
    <div className="tsk-lists-wrap">
      {employeesList && employeesList.length > 0 ? (
        <div className="tsk-lists nam rol des rep emil trin">
          <div className="dtls-mn-sec">
            <div className="d-flex list-headings">
              <p className="d-flex lst-img-nme">Name</p>
              <p className="d-flex role-wid">Role</p>
              <p className="d-flex dsgt-wid">Designation</p>
              <p className="d-flex rept-wid">Reporting to</p>
              <p className="d-flex eml-wid">Email</p>
              <p className="d-flex trin-wid">Training Video</p>
            </div>
            <div className="lst-tsk-main">
              {employeesList.map((employees: Employees, index) => (
                <EmployeeTable
                  key={index}
                  employees={employees}
                  enableSidePanel={enableSidePanel}
                  employeeListMutate={employeeListMutate}
                  setSelectedEmployee={setSelectedEmployee}
                  selectedEmployee={selectedEmployee}
                  employeesList={employeesList}
                  employeeDetails={employeeDetails}
                  selectedTeam={selectedTeam}
                  myToast={myToast}
                  permissions={permissions}
                />
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div className="tsk-lists empty-screen-wrap">
          <div className="card-ui">
            <div className="icon-block-wrap">
              {" "}
              <span className="tsk-icon material-icons-round">
                ramen_dining
              </span>{" "}
            </div>
            <h3>Look like there’s currently nothing to see here</h3>
            <p> No results were found. Request to add employee. </p>
          </div>
        </div>
      )}
    </div>
  );
};

const EmployeeTable = ({
  employees,
  setSelectedEmployee,
  selectedEmployee,
  enableSidePanel,
  employeeDetails,
  employeeListMutate,
  selectedTeam,
  myToast,
  permissions,
}: {
  employees: Employees;
  employeesList: Employees[] | undefined;
  setSelectedEmployee: React.Dispatch<React.SetStateAction<string>>;
  employeeListMutate: any;
  selectedEmployee: string;
  enableSidePanel: React.Dispatch<React.SetStateAction<boolean>>;
  employeeDetails: EmployeeType | undefined;
  selectedTeam: string;
  myToast: any;
  permissions: string[];
}) => {
  const [selectedName, setSelectedName] = useState<string | undefined>();
  const [selectedDesignation, setSelectedDesignation] = useState<
    string | undefined
  >();

  const [showTrainingQueueModal, setTrainingQueueShow] = useState(false);
  const handleTrainingQueueModelClose = () => setTrainingQueueShow(false);

  const [showTrainingQueueWatchModal, setTrainingQueueWatchShow] =
    useState(false);
  const handleTrainingQueueWatchModelClose = () =>
    setTrainingQueueWatchShow(false);

  const {
    _id,
    profilepic,
    name,
    designation,
    reporting_to_profilepic,
    reporting_to,
    email_id,
    role,
    training_video,
    training_video_key,
  } = employees;

  const handleClick = () => {
    setSelectedEmployee(_id);
    enableSidePanel(true);
  };

  const handleClickTrainingQueue = () => {
    setTrainingQueueShow(true);
  };

  const handleClickTrainingQueueWatch = () => {
    setTrainingQueueWatchShow(true);
  };

  return (
    <div className={`lst-tsk-main`}>
      <div
        className={`d-flex lst-tsk-nm ${
          _id === selectedEmployee ? "clicked" : ""
        }`}
      >
        <div
          className="d-flex lst-img-nme table-inner-cells"
          onClick={handleClick}
        >
          <div className="d-flex">
            <div className="user-img-details-last-updated d-flex">
              {profilepic ? (
                <div className="user-image-block-sm">
                  {/* <img src={profilepic} alt=""
                                className="img-fluid" /> */}
                  <DefaultImage
                    src={profilepic}
                    alt=""
                    className="img-fluid"
                    letter={name[0]}
                  />
                </div>
              ) : (
                <div className="user-image-block-sm">
                  {/* <img src={defaultpicture} alt=""
                                className="img-fluid" /> */}
                  <DefaultImage
                    src={profilepic}
                    alt=""
                    className="img-fluid"
                    letter={name[0]}
                  />
                </div>
              )}
              <div className="user-name-last-update">{name}</div>
            </div>
          </div>
        </div>
        <div
          className="d-flex role-wid table-inner-cells"
          onClick={handleClick}
        >
          <p className="flex-align-center">{role}</p>
        </div>
        <div
          className="d-flex dsgt-wid table-inner-cells"
          onClick={handleClick}
        >
          <p className="flex-align-center">{designation}</p>
        </div>
        <div
          className="d-flex rept-wid table-inner-cells"
          onClick={handleClick}
        >
          <div className="user-img-details-last-updated d-flex">
            <div className="user-image-block-sm">
              {/* <img src={reporting_to_profilepic} alt="" className="img-fluid" /> */}
              <DefaultImage
                src={reporting_to_profilepic}
                alt=""
                className="img-fluid"
                letter={reporting_to?.[0] || ""}
              />
            </div>
            <div className="user-name-last-update">{reporting_to}</div>
          </div>
        </div>
        <div className="d-flex eml-wid table-inner-cells" onClick={handleClick}>
          <p className="flex-align-center">{email_id}</p>
        </div>
        <div className="d-flex trin-wid table-inner-cells">
          {/* <p className="flex-align-center">{training_video}</p> */}

          {showTrainingQueueWatchModal ? (
            <TrainingQueueVideoWatchModel
              employeesData={employees}
              name={name}
              designation={designation}
              selectedEmployee={selectedEmployee}
              setshowTrainingQueueWatchModal={setTrainingQueueWatchShow}
              setSelectedEmployee={setSelectedEmployee}
              showTrainingQueueWatchModal={showTrainingQueueWatchModal}
              handleTrainingQueueWatchModelClose={
                handleTrainingQueueWatchModelClose
              }
              employeeDetails={employeeDetails}
              selectedTeam={selectedTeam}
              myToast={myToast}
              permissions={permissions}
            />
          ) : null}

          {training_video_key ? (
            <div className="d-flex trng-wid watch">
              <button
                className="btn"
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#team-member-details"
                onClick={handleClickTrainingQueueWatch}
              >
                <span className="material-symbols-rounded"> play_arrow </span>{" "}
                <span className="btn-inner-text"> Watch </span>
              </button>
            </div>
          ) : (
            <>
              {hasPermission(permissions, [
                "uploadvideo:read",
                "uploadvideo:write",
              ]) && (
                <div className="d-flex trng-wid">
                  <button
                    className="btn btn-upload"
                    onClick={handleClickTrainingQueue}
                  >
                    <span className="material-symbols-rounded"> Upload </span>
                    <span className="btn-inner-text"> Upload </span>
                  </button>
                </div>
              )}
            </>
          )}
          {showTrainingQueueModal ? (
            <TrainingQueueVideoModel
              employeesData={employees}
              name={name}
              employeeListMutate={employeeListMutate}
              designation={designation}
              selectedEmployee={selectedEmployee}
              setshowTrainingQueueModal={setTrainingQueueShow}
              setSelectedEmployee={setSelectedEmployee}
              showTrainingQueueModal={showTrainingQueueModal}
              handleTrainingQueueModelClose={handleTrainingQueueModelClose}
              employeeDetails={employeeDetails}
              selectedTeam={selectedTeam}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

const TrainingQueueVideoModel = ({
  employeesData,
  setshowTrainingQueueModal,
  selectedEmployee,
  employeeListMutate,
  setSelectedEmployee,
  name,
  designation,
  showTrainingQueueModal,
  handleTrainingQueueModelClose,
  employeeDetails,
  selectedTeam,
}: {
  setshowTrainingQueueModal: React.Dispatch<React.SetStateAction<boolean>>;
  selectedEmployee: string;
  employeeListMutate: any;
  employeesData: Employees;
  setSelectedEmployee: React.Dispatch<React.SetStateAction<string>>;
  name: string;
  designation: Teams;
  showTrainingQueueModal: boolean;
  handleTrainingQueueModelClose: () => void;
  employeeDetails: EmployeeType | undefined;
  selectedTeam: string;
}) => {
  setshowTrainingQueueModal(true);

  const handleTrainingQueueModelForm = async () => {
    handleTrainingQueueModelClose();
  };

  const video: any = useRef(null);

  const handleClick = async (values: any, e: any) => {
    const formData = new FormData();
    formData.append("training_video", values);

    const result = await updateTrainingVideo(employeesData._id, formData);

    handleTrainingQueueModelClose();
    employeeListMutate();
  };

  const handleCancel = () => {
    handleTrainingQueueModelClose();
  };

  return (
    <Dialog
      visible={showTrainingQueueModal}
      onHide={() => handleTrainingQueueModelClose()}
      style={{ width: "50vw" }}
      header={"Training Video"}
    >
      <Formik
        initialValues={employeesData}
        onSubmit={handleTrainingQueueModelForm}
      >
        {({ errors, values, touched, isSubmitting, setFieldValue }) => {
          return (
            <Form>
              <div className="modal-content">
                <div
                  className={`${
                    !values.training_video
                      ? "modal-body upload-wrap-group active-uploading-ui"
                      : "modal-body upload-wrap-group"
                  }`}
                  id="upload-wrap-group"
                >
                  <div className="uplaod-wrap-main">
                    <div className="details-body">
                      <div className="md-padding">
                        <div className="point-details">
                          <div className="lst-tsk-nm dtls-update">
                            <div className="d-flex list-headings">
                              <p className="d-flex">Name</p>
                              <div className="drpdwn-slct">
                                <p className="flex-align-center">{name}</p>
                              </div>
                            </div>
                            <div className="d-flex list-headings">
                              <p className="d-flex">Designation</p>
                              <div className="drpdwn-slct">
                                <p className="flex-align-center">
                                  {designation}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <video ref={video} width="320" height="240" controls></video> */}
                    </div>
                    <div className="drag-upload-file">
                      <div className="drag-upload-type">
                        <div className="drag-upload-item drag-file-ui">
                          <span className="material-symbols-rounded">
                            {" "}
                            Upload{" "}
                          </span>
                          <div> Drag File Here </div>
                        </div>
                        <div className="drag-upload-item drag-or-select-info">
                          {" "}
                          OR{" "}
                        </div>

                        <div className="drag-upload-item drag-select-file-ui">
                          <div className="file-input">
                            <input
                              type="file"
                              name="file-input"
                              id="file-input"
                              className="file-input__input"
                              onChange={(event: any) => {
                                const file = event.currentTarget.files[0];
                                const blobURL = URL.createObjectURL(file);
                                video.current.src = blobURL;
                                setFieldValue("training_video", file);
                              }}
                            />
                            <label
                              className="file-input__label"
                              htmlFor="file-input"
                            >
                              <span> Select A File </span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="video-ready-to-play"
                    id="drag-frame-height-control"
                  >
                    <div className="details-body">
                      <div className="md-padding">
                        <div className="point-details">
                          <div className="lst-tsk-nm dtls-update">
                            <div className="d-flex list-headings">
                              <p className="d-flex">First Name</p>
                              <div className="drpdwn-slct">
                                <p className="flex-align-center">{name}</p>
                              </div>
                            </div>
                            <div className="d-flex list-headings">
                              <p className="d-flex">Designation</p>
                              <div className="drpdwn-slct">
                                <p className="flex-align-center">
                                  {designation}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <video
                        ref={video}
                        width="320"
                        height="240"
                        controls
                      ></video>
                    </div>
                    <div className="modal-footer" id="modal-footer">
                      <div>
                        {/* <button className="btn btn-primary-outline btn-icon">
                                                           <span className="material-symbols-rounded"> upload </span>
                                                           <span className="btn-inner-text" > Reupload </span>
                                                           </button> */}
                        <div className="drag-upload-item drag-select-file-ui">
                          <div className="file-input">
                            <input
                              type="file"
                              name="file-input"
                              id="file-input"
                              className="file-input__input"
                              onChange={(event: any) => {
                                const file = event.currentTarget.files[0];
                                const blobURL = URL.createObjectURL(file);
                                video.current.src = blobURL;
                                setFieldValue("training_video", file);
                                console.log("file", file);
                              }}
                            />
                            <label
                              className="file-input__label"
                              htmlFor="file-input"
                            >
                              <span className="material-symbols-rounded">
                                {" "}
                                upload{" "}
                              </span>
                              <span className="btn-inner-text"> Reupload </span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex">
                        <button
                          type="button"
                          className="btn cancel"
                          onClick={handleCancel}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          data-bs-dismiss="modal"
                          onClick={(e: any) =>
                            handleClick(values.training_video, e)
                          }
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
};

const TrainingQueueVideoWatchModel = ({
  employeesData,
  selectedEmployee,
  setSelectedEmployee,
  name,
  designation,
  employeeDetails,
  selectedTeam,
  showTrainingQueueWatchModal,
  handleTrainingQueueWatchModelClose,
  setshowTrainingQueueWatchModal,
  myToast,
  permissions,
}: {
  selectedEmployee: string;
  employeesData: Employees;
  setSelectedEmployee: React.Dispatch<React.SetStateAction<string>>;
  name: string;
  designation: Teams;
  employeeDetails: EmployeeType | undefined;
  selectedTeam: string;
  showTrainingQueueWatchModal: boolean;
  setshowTrainingQueueWatchModal: React.Dispatch<React.SetStateAction<boolean>>;
  handleTrainingQueueWatchModelClose: () => void;
  myToast: any;
  permissions: string[];
}) => {
  setshowTrainingQueueWatchModal(true);

  const handleTrainingQueueWatchModelForm = async () => {
    handleTrainingQueueWatchModelClose();
  };

  const video: any = useRef(null);

  const handleClick = async (values: any, e: any) => {
    const formData = new FormData();
    formData.append("training_video", values);
    const result = await updateTrainingVideo(employeesData._id, formData);

    handleTrainingQueueWatchModelClose();
  };

  // const getEmployeeTrainingVideo = await getEmployeeList(employeesData.training_video_key)

  const handleCancel = () => {
    handleTrainingQueueWatchModelClose();
  };

  const showToast = (
    severityValue: string,
    summaryValue: string,
    detailValue: string
  ) => {
    myToast.current.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };

  const handleDelete = async (employeeId: string) => {
    try {
      const result = await deleteEmployeeTrainingVideo(employeeId);
      if (result.status === 200) {
        showToast(
          "success",
          "Success Message",
          "Video was deleted successfully."
        );
      }
    } catch (error) {
      console.log(error);
    }
    handleTrainingQueueWatchModelClose();
  };

  return (
    <Dialog
      visible={showTrainingQueueWatchModal}
      onHide={() => handleTrainingQueueWatchModelClose()}
      style={{ width: "50vw" }}
      header={"Training Video"}
    >
      <Formik
        initialValues={employeesData}
        onSubmit={handleTrainingQueueWatchModelForm}
      >
        {({ errors, values, touched, isSubmitting, setFieldValue }) => {
          return (
            <Form>
              <div className="modal-content">
                <div
                  className="modal-body upload-wrap-group"
                  id="upload-wrap-group"
                >
                  <div
                    className="video-ready-to-play"
                    id="drag-frame-height-control"
                  >
                    <div className="details-body">
                      <div className="md-padding">
                        <div className="point-details">
                          <div className="lst-tsk-nm dtls-update">
                            <div className="d-flex list-headings">
                              <p className="d-flex">First Name</p>
                              <div className="drpdwn-slct">
                                <p className="flex-align-center">{name}</p>
                              </div>
                            </div>
                            <div className="d-flex list-headings">
                              <p className="d-flex">Designation</p>
                              <div className="drpdwn-slct">
                                <p className="flex-align-center">
                                  {designation}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <video
                        src={employeesData.training_video_key}
                        ref={video}
                        width="320"
                        height="240"
                        controls
                      ></video>
                    </div>

                    {hasPermission(permissions, ["uploadvideo:write"]) && (
                      <div className="modal-footer" id="modal-footer">
                        <div>
                          <div className="drag-upload-item drag-select-file-ui">
                            <div className="file-input">
                              <input
                                type="file"
                                name="file-input"
                                id="file-input"
                                className="file-input__input"
                                onChange={(event: any) => {
                                  const file = event.currentTarget.files[0];
                                  const blobURL = URL.createObjectURL(file);
                                  video.current.src = blobURL;
                                  setFieldValue("training_video", file);
                                }}
                              />
                              <label
                                className="file-input__label"
                                htmlFor="file-input"
                              >
                                <span className="material-symbols-rounded">
                                  {" "}
                                  upload{" "}
                                </span>
                                <span className="btn-inner-text">
                                  {" "}
                                  Reupload{" "}
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div>
                          <button
                            type="button"
                            className="btn delete delete-full-btn"
                            onClick={() => handleDelete(employeesData._id)}
                          >
                            Delete
                          </button>
                        </div>
                        <div className="d-flex">
                          <button
                            type="button"
                            className="btn cancel"
                            onClick={handleCancel}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary"
                            data-bs-dismiss="modal"
                            onClick={(e: any) =>
                              handleClick(values.training_video, e)
                            }
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
};

const TeamModal = ({
  myToast,
  employeeListMutate,
  isTeamUpdate,
  showTeamModal,
  handleTeamClose,
  handleTeamShow,
  employeesList,
  teamMutate,
  setSelectedTeamName,
  setSelectedTeam,
  teamFields,
  assignees,
  refreshTaskList,
}: {
  showTeamModal: boolean;
  handleTeamClose: () => void;
  handleTeamShow: () => void;
  isTeamUpdate: boolean;
  teamFields: TeamForm;
  assignees: AssigneeType[];
  refreshTaskList: any;
  myToast: any;
  setSelectedTeam: React.Dispatch<React.SetStateAction<string>>;
  teamMutate: any;
  setSelectedTeamName: React.Dispatch<React.SetStateAction<string>>;
  employeeListMutate: any;
  employeesList: Employees[];
}) => {
  const [teamModelButtonDisabled, setTeamModelButtonDisabled] = useState(false);
  const [hasShownWarning, setHasShownWarning] = useState(false);

  const teamFormValidation = Yup.object({
    name: Yup.string()
      .required("*")
      .matches(
        /^[a-zA-Z\s]+$/,
        "This field cannot contain numbers and special characters"
      ),
    // manager: Yup.string(),
    description: Yup.string().max(
      180,
      "Description must be at most 180 characters"
    ),
  });

  const workScheduleList = [
    { _id: "ALLSUNDAYOFF", name: "ALLSUNDAYOFF" },
    { _id: "ALLSATURDAYOFF", name: "ALLSATURDAYOFF" },
    { _id: "ALLSATURDAYSUNDAYOFF", name: "ALLSATURDAYSUNDAYOFF" },
    { _id: "ALTERNATIVEWEEKENDOFF", name: "ALTERNATIVEWEEKENDOFF" },
    { _id: "ALL7DAYS1OFF", name: "ALL7DAYS1OFF" },
  ];

  const showToast = (
    severityValue: string,
    summaryValue: string,
    detailValue: string
  ) => {
    myToast.current.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };

  const assgineesOptionTemplate = (option: any) => {
    return (
      <div className="d-flex sm-user-name">
        {/* { option.profilepic ? <img src={option.profilepic} />: <img src={defaultpicture} />} */}
        <DefaultImage
          src={option.profilepic}
          alt=""
          className=""
          letter={option.name[0]}
        />
        <div>{option.name}</div>
      </div>
    );
  };

  const selectedAssgineesTemplate = (option: any, props: any) => {
    if (option) {
      return (
        <div className="d-flex sm-user-name">
          {/* { option.profilepic ? <img src={option.profilepic} />: <img src={defaultpicture} />} */}
          <DefaultImage
            src={option.profilepic}
            alt=""
            className=""
            letter={option.name[0]}
          />
          <div>{option.name}</div>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  const handleTeamForm = async (values: TeamForm) => {
    const { _id, name, manager, description, work_schedule } = values;
    let result;
    try {
      if (isTeamUpdate && _id) {
        result = await updateTeam(_id, values);
        if (result.status === 200) {
          showToast(
            "success",
            "Success Message",
            "Team was updated successfully."
          );
        }
        setSelectedTeamName(name);
        teamMutate();
      } else {
        result = await createTeam({
          name,
          manager,
          description,
          work_schedule,
        });
        if (result.statusCode === 201) {
          showToast(
            "success",
            "Success Message",
            "Team was created successfully."
          );
        }
      }
      refreshTaskList();
    } catch (error) {
      showToast("warn", "Warning", "Team name already exists");
      console.log(error);
    }
    employeeListMutate();
    handleTeamClose();
    setTeamModelButtonDisabled(false);
  };
  useEffect(() => {
    if (hasShownWarning) {
      showToast("warn", "Warning", "Kindly fill the required fields!");
    }
  }, [hasShownWarning]);

  return (
    <Dialog
      visible={showTeamModal}
      onHide={handleTeamClose}
      style={{ width: "50vw" }}
      header={!isTeamUpdate ? "Create a Team" : "Update Team"}
      className="details-edit-body dtls-update"
    >
      <Formik
        initialValues={teamFields}
        validationSchema={teamFormValidation}
        onSubmit={(values) => {
          setTeamModelButtonDisabled(true);
          handleTeamForm(values);
        }}
      >
        {({ errors, values, touched, isSubmitting }) => {
          if (Object.keys(errors).length > 0 && isSubmitting) {
            setHasShownWarning(true);
          } else {
            setHasShownWarning(false);
          }
          return (
            <Form>
              <div className="modal-body-inner pt-0">
                {errors.name && touched.name ? (
                  <span style={{ color: "red" }}>*</span>
                ) : null}
                <div className="form-group lg-input">
                  <Field type="text" name="name" placeholder="Team Name *" />
                </div>
                <div className="lst-tsk-nm mb-0">
                  <div className="dtls-update">
                    <div className="d-flex list-headings">
                      <p className="d-flex">MANAGER </p>
                      <div className="drpdwn-slct">
                        <Field name="manager">
                          {({ field }: { field: any }) => {
                            return (
                              <Dropdown
                                name="manager"
                                optionLabel="name"
                                optionValue="_id"
                                value={field.value}
                                onChange={field.onChange}
                                options={assignees?.filter(
                                  (e: any) => e?.role?.role_name === "Manager"
                                )}
                                itemTemplate={assgineesOptionTemplate}
                                valueTemplate={selectedAssgineesTemplate}
                                placeholder="Select"
                              />
                            );
                          }}
                        </Field>
                      </div>
                    </div>

                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        WORK SCHEDULE{" "}
                        {errors.work_schedule && touched.work_schedule ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      <div className="drpdwn-slct">
                        <Field name="work_schedule">
                          {({ field }: { field: any }) => {
                            return (
                              <Dropdown
                                name="work_schedule"
                                optionLabel="name"
                                optionValue="_id"
                                value={field.value}
                                onChange={field.onChange}
                                options={workScheduleList}
                                placeholder="Select"
                              />
                            );
                          }}
                        </Field>
                      </div>
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">DESCRIPTION </p>
                      <div className="drpdwn-slct">
                        <Field name="description" as="textarea"></Field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <div>
                  {isTeamUpdate && values._id && employeesList?.length == 0 ? (
                    <Button
                      type="button"
                      className="btn delete delete-full-btn"
                      onClick={() =>
                        confirmDeleteTeam(
                          values._id,
                          handleTeamShow,
                          refreshTaskList,
                          setSelectedTeam,
                          handleTeamClose,
                          myToast
                        )
                      }
                      label="Delete"
                    ></Button>
                  ) : (
                    ""
                  )}
                </div>
                <div className="d-flex">
                  <button
                    type="button"
                    className="btn cancel"
                    data-bs-dismiss="modal"
                    onClick={handleTeamClose}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn save"
                    disabled={teamModelButtonDisabled || isSubmitting}
                  >
                    {!isTeamUpdate ? "Add" : "Save"}{" "}
                  </button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
};

const confirmDeleteTeam = (
  teamId: string | undefined,
  handleTeamShow: () => void,
  refreshTaskList: any,
  setSelectedTeam: React.Dispatch<React.SetStateAction<string>>,
  handleTeamClose: () => void,
  myToast: any
) => {
  confirmDialog({
    message: "Do you want to delete this record?",
    header: "Confirmation",
    className: "mini-alert-popup-ui",
    icon: "pi pi-exclamation-circle",
    accept: () =>
      deleteTeamItem(
        teamId,
        refreshTaskList,
        setSelectedTeam,
        handleTeamClose,
        myToast
      ),
    reject: () => handleTeamShow(),
  });

  const deleteTeamItem = async (
    teamId: string | undefined,
    refreshTaskList: any,
    setSelectedTeam: React.Dispatch<React.SetStateAction<string>>,
    handleTeamClose: () => void,
    myToast: any
  ) => {
    const showToast = (
      severityValue: string,
      summaryValue: string,
      detailValue: string
    ) => {
      myToast.current.show({
        severity: severityValue,
        summary: summaryValue,
        detail: detailValue,
      });
    };
    if (teamId) {
      try {
        let result = await deleteTeam(teamId);
        if (result.status === 200) {
          showToast(
            "success",
            "Success Message",
            "Team was deleted successfully."
          );
        }
      } catch (error) {
        showToast("warn", "Warning", "User exists in this department!");
        console.log(error);
      }
      setSelectedTeam("All");
      refreshTaskList();
      handleTeamClose();
    }
  };
};

const EmployeeModal = ({
  teamsList,
  myToast,
  teamMutate,
  hiddenFileInput,
  selectedTeam,
  showEmployeeModal,
  selectImage,
  setSelectedImage,
  rolesList,
  selectFilePath,
  setSelectedFilePath,
  designationList,
  handleEmployeeClose,
  refreshEmployeeList,
  setSelectedEmployee,
  role,
  employeeNumber,
  employeesList,
  assignees,
  teamDetails,
  selectedReportingPerson,
}: {
  selectImage: string | undefined;
  selectVideo: string | undefined;
  teamMutate: any;
  setSelectedImage: React.Dispatch<React.SetStateAction<string | undefined>>;
  setSelectedVideo: React.Dispatch<React.SetStateAction<string | undefined>>;
  selectFilePath: string | undefined;
  setSelectedFilePath: React.Dispatch<React.SetStateAction<string | undefined>>;
  myToast: any;
  teamsList: TeamList[] | undefined;
  hiddenFileInput: any;
  designationList: Designation[] | undefined;
  rolesList: Roles[] | undefined;
  showEmployeeModal: boolean;
  handleEmployeeClose: () => void;
  refreshEmployeeList: any;
  selectedTeam: string;
  setSelectedEmployee: React.Dispatch<React.SetStateAction<string>>;
  role: string | undefined;
  employeeNumber: string;
  employeesList: Employees[];
  assignees: AssigneeType[];
  teamDetails: TeamList | undefined;
  selectedReportingPerson: string;
}) => {
  const [employeeModalButtonDisabled, setEmployeeModalButtonDisabled] =
    useState(false);
  const [hasShownWarning, setHasShownWarning] = useState(false);

  let employeeForm: EmployeeForm = {
    _id: "",
    profilepic: "",
    first_name: "",
    last_name: "",
    gender: "",
    father_name: "",
    mother_name: "",
    marital_status: "",
    training_video: "",
    role: "",
    designation: "",
    department: selectedTeam,
    reporting_to: selectedReportingPerson,
    type: "",
    skype_id: "",
    date_of_birth: "",
    date_of_joining: "",
    email_id: "",
    phonenumber: "",
    personal_emailId: "",
    linkedIn_id: "",
    bank_details: "",
    pan_number: "",
    aadhar_number: "",
    esi_number: "",
    uan_number: "",
    alternative_phonenumber: "",
    address: "",
    employee_number: "",
    casual_leave: "",
    sick_leave: "",
    privileged_leave: "",
    total_leave_allocated: "",
    total_leave_approved: "",
    isactive_user: true,
  };

  const employeeFormValidation = Yup.object({
    profilepic: Yup.string(),
    first_name: Yup.string()
      .matches(/^[A-Za-z ]+$/g, "only letters is valid")
      .required("*"),
    last_name: Yup.string()
      .matches(/^[A-Za-z ]+$/g, "only letters is valid")
      .required("*"),
    gender: Yup.string().required("*"),
    father_name: Yup.string(),
    mother_name: Yup.string(),
    marital_status: Yup.string(),
    training_video: Yup.string(),
    role: Yup.mixed().notOneOf(["select"]).required(),
    designation: Yup.mixed().notOneOf(["select"]).required(),
    department: Yup.string().required("*"),
    // reporting_to:Yup.string(),
    type: Yup.string(),
    skype_id: Yup.string(),
    date_of_birth: Yup.date().required("*").nullable(),
    date_of_joining: Yup.date().required("*").nullable(),
    email_id: Yup.string()
      .matches(
        /^[A-Za-z0-9._%+-]+@solutionchamps.com$/g,
        "only solutionchamps domain is valid"
      )
      .required("*"),
    personal_emailId: Yup.string(),
    linkedIn: Yup.string(),
    bank_details: Yup.string(),
    pan_number: Yup.string(),
    aadhar_number: Yup.string()
      .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/g,
        "Aadhar number is not valid"
      )
      .min(12, "Invalid aadhar number")
      .max(12, "Invalid aadhar number"),
    esi_number: Yup.string(),
    uan_number: Yup.string(),
    phonenumber: Yup.string()
      .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/g,
        "Phone number is not valid"
      )
      .min(10, "Invalid phone number")
      .max(10, "Invalid phone number")
      .required("*"),
    alternative_phonenumber: Yup.string()
      .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/g,
        "Phone number is not valid"
      )
      .min(10, "Invalid phone number")
      .max(10, "Invalid phone number"),
    address: Yup.string(),
    employee_number: Yup.string(),
  });

  const showToast = (
    severityValue: string,
    summaryValue: string,
    detailValue: string
  ) => {
    myToast.current.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };

  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  const handleChange = async (event: any) => {
    const fileUploaded = event.target.files[0];
    let formData = new FormData();

    formData.append("file", fileUploaded);
    formData.append("intent", "userprofile");
    const result = await getImageFileUrl(formData);
    setSelectedImage(result.url);
    setSelectedFilePath(result.fileKey);
  };

  const handleEmployeeForm = async (values: EmployeeForm) => {
    const {
      first_name,
      last_name,
      role,
      designation,
      department,
      reporting_to,
      type,
      skype_id,
      date_of_birth,
      date_of_joining,
      email_id,
      phonenumber,
      alternative_phonenumber,
      address,
      personal_emailId,
      linkedIn_id,
      bank_details,
      pan_number,
      aadhar_number,
      gender,
      father_name,
      mother_name,
      marital_status,
      esi_number,
      uan_number,
      employee_number,
    } = values;
    try {
      const resp = await createEmployee({
        profilepic: selectFilePath ? selectFilePath : "",
        first_name,
        last_name,
        training_video: selectFilePath ? selectFilePath : "",
        role,
        designation,
        department,
        reporting_to,
        type,
        skype_id,
        date_of_birth,
        date_of_joining,
        email_id,
        phonenumber,
        alternative_phonenumber,
        address,
        personal_emailId,
        linkedIn_id,
        bank_details,
        pan_number,
        aadhar_number,
        gender,
        father_name,
        mother_name,
        marital_status,
        esi_number,
        uan_number,
        employee_number,
        isactive_user: true,
      });
      if (resp) {
        showToast(
          "success",
          "Success Message",
          "Employee was created successfully."
        );
      }
      refreshEmployeeList();
      setSelectedImage(undefined);
      teamMutate();
    } catch (error) {
      console.log(error);
      showToast("warn", "Warning", "User already exists!");
    }
    handleEmployeeClose();
    setEmployeeModalButtonDisabled(false);
  };

  const cancelAddEmployee = () => {
    setSelectedImage(undefined);
    handleEmployeeClose();
  };

  const EmployeeOnHide = () => {
    setSelectedImage(undefined);
    handleEmployeeClose();
  };

  const assgineesOptionTemplate = (option: any) => {
    return (
      <div className="d-flex sm-user-name">
        {/* { option.profilepic ? <img src={option.profilepic} />: <img src={defaultpicture} />} */}
        <DefaultImage
          src={option.profilepic}
          alt=""
          className=""
          letter={option.name[0]}
        />
        <div>{option.name}</div>
      </div>
    );
  };

  const selectedAssgineesTemplate = (option: any, props: any) => {
    if (option) {
      return (
        <div className="d-flex sm-user-name">
          {/* { option.profilepic ? <img src={option.profilepic} />: <img src={defaultpicture} />} */}
          <DefaultImage
            src={option.profilepic}
            alt=""
            className=""
            letter={option.name[0]}
          />
          <div>{option.name}</div>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  useEffect(() => {
    if (hasShownWarning) {
      showToast("warn", "Warning", "Kindly fill the required fields!");
    }
  }, [hasShownWarning]);

  return (
    <Dialog
      visible={showEmployeeModal}
      onHide={() => EmployeeOnHide()}
      style={{ width: "50vw" }}
      header={"Create a Member"}
      className="details-edit-body dtls-update"
    >
      <Formik
        initialValues={employeeForm}
        validationSchema={employeeFormValidation}
        onSubmit={(values: any) => {
          setEmployeeModalButtonDisabled(true);
          handleEmployeeForm(values);
        }}
      >
        {({ errors, touched, values, isSubmitting }) => {
          if (Object.keys(errors).length > 0 && isSubmitting) {
            setHasShownWarning(true);
          } else {
            setHasShownWarning(false);
          }
          return (
            <Form>
              <div className="modal-content">
                <div className="modal-body">
                  <div className="modal-body-inner p-0">
                    <div className="team-user-image">
                      <div className="team-user-image-inner">
                        <button
                          className="d-flex add-time"
                          type="button"
                          onClick={() => handleClick()}
                        >
                          <span className="material-icons-outlined">
                            photo_camera
                          </span>
                        </button>
                        <img src={selectImage} alt="" />
                        <input
                          type="file"
                          ref={hiddenFileInput}
                          onChange={handleChange}
                          style={{ display: "none" }}
                        />
                      </div>
                    </div>
                    <div className="dtls-update">
                      <div className="d-flex list-headings">
                        <p className="d-flex">EMPLOYEE NUMBER</p>
                        <div className="drpdwn-slct">
                          <Field name="employee_number" />
                        </div>
                      </div>
                    </div>
                    <div className="lst-tsk-nm">
                      <div className="dtls-update">
                        <div className="d-flex list-headings">
                          <p className="d-flex">
                            FIRST NAME{" "}
                            {errors.first_name && touched.first_name ? (
                              <span style={{ color: "red" }}>*</span>
                            ) : null}
                          </p>
                          <div className="drpdwn-slct">
                            <Field name="first_name" />
                          </div>
                        </div>
                        <div className="d-flex list-headings">
                          <p className="d-flex">
                            LAST NAME{" "}
                            {errors.last_name && touched.last_name ? (
                              <span style={{ color: "red" }}>*</span>
                            ) : null}
                          </p>
                          <div className="drpdwn-slct">
                            <Field name="last_name" />
                          </div>
                        </div>
                        <div className="d-flex list-headings">
                          <p className="d-flex">
                            GENDER
                            {errors.gender && touched.gender ? (
                              <span style={{ color: "red" }}>*</span>
                            ) : null}
                          </p>
                          <div className="drpdwn-slct">
                            <Field name="gender">
                              {({ field }: { field: any }) => (
                                <select {...field} name="gender">
                                  <option value="">Select</option>
                                  <option value="Male"> Male </option>
                                  <option value="Female"> Female </option>
                                  <option value="Others"> Others </option>
                                </select>
                              )}
                            </Field>
                          </div>
                        </div>

                        <div className="d-flex list-headings">
                          <p className="d-flex">MARITAL STATUS</p>
                          <div className="drpdwn-slct">
                            <Field name="marital_status">
                              {({ field }: { field: any }) => (
                                <select {...field} name="marital_status">
                                  <option value="">Select</option>
                                  <option value="Single"> Single </option>
                                  <option value="Married"> Married </option>
                                </select>
                              )}
                            </Field>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="point-details">
                      <div className="pro-name">Family Details</div>
                      <div className="lst-tsk-nm">
                        <div className="dtls-update">
                          <div className="d-flex list-headings">
                            <p className="d-flex">FATHER NAME</p>
                            <div className="drpdwn-slct">
                              <Field name="father_name" />
                            </div>
                          </div>

                          <div className="d-flex list-headings">
                            <p className="d-flex">MOTHER NAME</p>
                            <div className="drpdwn-slct">
                              <Field name="mother_name" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="point-details">
                      <div className="pro-name">General Details</div>
                      <div className="lst-tsk-nm">
                        <div className="dtls-update">
                          <div className="d-flex list-headings">
                            <p className="d-flex">
                              ROLE{" "}
                              {errors.role && touched.role ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : null}
                            </p>
                            <div className="drpdwn-slct">
                              <Field name="role">
                                {({ field }: { field: any }) => (
                                  <select {...field} name="role">
                                    <option value="">Select</option>
                                    {rolesList?.map((item, index) => (
                                      <option key={index} value={item._id}>
                                        {item.role_name}
                                      </option>
                                    ))}
                                  </select>
                                )}
                              </Field>
                            </div>
                          </div>
                          <div className="d-flex list-headings">
                            <p className="d-flex">
                              DESIGNATION{" "}
                              {errors.designation && touched.designation ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : null}
                            </p>
                            <div className="drpdwn-slct">
                              <Field name="designation">
                                {({ field }: { field: any }) => (
                                  <select {...field} name="designation">
                                    <option value="">Select</option>
                                    {designationList?.map((item, index) => (
                                      <option key={index} value={item._id}>
                                        {item.name}
                                      </option>
                                    ))}
                                  </select>
                                )}
                              </Field>
                            </div>
                          </div>
                          <div className="d-flex list-headings">
                            <p className="d-flex">
                              DEPARTMENT{" "}
                              {errors.department && touched.department ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : null}
                            </p>
                            <div className="drpdwn-slct">
                              <Field name="department">
                                {({ field }: { field: any }) => (
                                  <select {...field} disabled>
                                    <option value="">Select</option>
                                    {teamsList?.map((item, index) => (
                                      <option key={index} value={item._id}>
                                        {item.name}
                                      </option>
                                    ))}
                                  </select>
                                )}
                              </Field>
                            </div>
                          </div>

                          <div className="d-flex list-headings">
                            <p className="d-flex">REPORTING_TO</p>
                            <div className="drpdwn-slct">
                              <Field name="reporting_to">
                                {({ field }: { field: any }) => {
                                  return (
                                    <Dropdown
                                      name="reporting_to"
                                      optionLabel="name"
                                      optionValue="_id"
                                      value={field.value}
                                      onChange={field.onChange}
                                      options={assignees}
                                      itemTemplate={assgineesOptionTemplate}
                                      valueTemplate={selectedAssgineesTemplate}
                                      placeholder="Select"
                                    />
                                  );
                                }}
                              </Field>
                            </div>
                          </div>

                          <div className="d-flex list-headings">
                            <p className="d-flex">
                              EMPLOYEE TYPE{" "}
                              {errors.type && touched.type ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : null}
                            </p>
                            <div className="drpdwn-slct">
                              <Field name="type">
                                {({ field }: { field: any }) => (
                                  <select {...field} name="type">
                                    <option value="">Select</option>
                                    <option value="Probation">
                                      {" "}
                                      Probation{" "}
                                    </option>
                                    <option value="Freelancer">
                                      {" "}
                                      Freelancer{" "}
                                    </option>
                                    <option value="Permanent">
                                      {" "}
                                      Permanent{" "}
                                    </option>
                                    <option value="Contract"> Contract </option>
                                  </select>
                                )}
                              </Field>
                            </div>
                          </div>
                          <div className="d-flex list-headings">
                            <p className="d-flex">SKYPE ID</p>
                            <div className="drpdwn-slct">
                              <Field name="skype_id" />
                            </div>
                          </div>
                          <div className="d-flex list-headings">
                            <p className="d-flex">LINKEDIN ID</p>
                            <div className="drpdwn-slct">
                              <Field name="linkedIn_id" />
                            </div>
                          </div>

                          {role == "SuperAdmin" ? (
                            <div className="d-flex list-headings">
                              <p className="d-flex">PAN NUMBER</p>
                              <div className="drpdwn-slct">
                                <Field name="pan_number" />
                              </div>
                            </div>
                          ) : null}
                          {role == "SuperAdmin" ? (
                            <div className="d-flex list-headings">
                              <p className="d-flex">AADHAR NUMBER</p>
                              <div className="drpdwn-slct">
                                <Field name="aadhar_number" />
                                <ErrorMessage name="aadhar_number" />
                              </div>
                            </div>
                          ) : null}

                          {role == "SuperAdmin" ? (
                            <div className="d-flex list-headings">
                              <p className="d-flex">ESI NUMBER</p>
                              <div className="drpdwn-slct">
                                <Field name="esi_number" />
                              </div>
                            </div>
                          ) : null}

                          {role == "SuperAdmin" ? (
                            <div className="d-flex list-headings">
                              <p className="d-flex">UAN NUMBER</p>
                              <div className="drpdwn-slct">
                                <Field name="uan_number" />
                              </div>
                            </div>
                          ) : null}

                          <div className="d-flex list-headings">
                            <p className="d-flex">
                              DATE OF BIRTH{" "}
                              {errors.date_of_birth && touched.date_of_birth ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : null}
                            </p>
                            <div className="drpdwn-slct">
                              <Field name="date_of_birth">
                                {({ field }: { field: any }) => (
                                  <Calendar
                                    placeholder="MM-DD-YYYY"
                                    name="date_of_birth"
                                    value={field.value}
                                    onChange={field.onChange}
                                    showIcon
                                    icon={"pi pi-calendar"}
                                    monthNavigator
                                    yearNavigator
                                    yearRange="1900:2200"
                                    maxDate={new Date()}
                                  />
                                )}
                              </Field>
                            </div>
                          </div>
                          <div className="d-flex list-headings">
                            <p className="d-flex">
                              DATE OF JOINING{" "}
                              {errors.date_of_joining &&
                              touched.date_of_joining ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : null}
                            </p>
                            <div className="drpdwn-slct">
                              <Field name="date_of_joining">
                                {({ field }: { field: any }) => (
                                  <Calendar
                                    placeholder="MM-DD-YYYY"
                                    name="date_of_joining"
                                    value={field.value}
                                    onChange={field.onChange}
                                    monthNavigator
                                    yearNavigator
                                    yearRange="1900:2200"
                                    showIcon
                                    icon={"pi pi-calendar"}
                                  />
                                )}
                              </Field>
                              <ErrorMessage name="date_of_joining" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="point-details">
                      <div className="pro-name">Contact Details</div>
                      <div className="lst-tsk-nm">
                        <div className="dtls-update">
                          <div className="d-flex list-headings">
                            <p className="d-flex">
                              EMAIL
                              {errors.email_id && touched.email_id ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : null}
                            </p>
                            <div className="drpdwn-slct">
                              <Field
                                name="email_id"
                                placeholder="example@solutionchamps.com"
                              />
                              <ErrorMessage name="email_id" />
                            </div>
                          </div>
                          <div className="d-flex list-headings">
                            <p className="d-flex">PERSONAL EMAIL</p>
                            <div className="drpdwn-slct">
                              <Field name="personal_emailId" />
                            </div>
                          </div>

                          <div className="d-flex list-headings">
                            <p className="d-flex">
                              PHONE NO
                              {errors.phonenumber && touched.phonenumber ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : null}
                            </p>
                            <div className="drpdwn-slct">
                              <Field name="phonenumber" />
                              <ErrorMessage name="phonenumber" />
                            </div>
                          </div>

                          <div className="d-flex list-headings">
                            <p className="d-flex">ALTERNATE PHONE NO</p>
                            <div className="drpdwn-slct">
                              <Field name="alternative_phonenumber" />
                              <ErrorMessage name="alternative_phonenumber" />
                            </div>
                          </div>

                          <div className="d-flex list-headings">
                            <p className="d-flex">ADDRESS</p>
                            <div className="drpdwn-slct">
                              <Field name="address" as="textarea" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {role == "SuperAdmin" ? (
                      <div className="point-details">
                        <div className="pro-name">Bank Details</div>
                        <div className="lst-tsk-nm">
                          <div className="dtls-update">
                            <div className="d-flex list-headings">
                              <p className="d-flex"> DETAILS</p>
                              <div className="drpdwn-slct">
                                <Field name="bank_details" as="textarea" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="modal-footer">
                  <div></div>
                  <div className="d-flex">
                    <button
                      type="button"
                      className="btn cancel"
                      data-bs-dismiss="modal"
                      onClick={cancelAddEmployee}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn save"
                      disabled={employeeModalButtonDisabled || isSubmitting}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
};

const EmployeeDetailsSidePanel = ({
  permissions,
  selectFilePath,
  myToast,
  hiddenFileInput,
  selectImage,
  setSelectedFilePath,
  setSelectedImage,
  employeeDataMutate,
  enableEmployeeEdit,
  enableSidePanel,
  setEnableEmployeeEdit,
  isEmpDataLoading,
  rolesList,
  designationList,
  teamsList,
  employeeDetails,
  setEnableSidePanel,
  handleSidePanelClose,
  refreshEmployeeList,
  setSelectedEmployee,
  role,
  assignees,
}: {
  selectFilePath: string | undefined;
  myToast: any;
  hiddenFileInput: any;
  employeeDataMutate: any;
  enableEmployeeEdit: boolean;
  selectImage: string | undefined;
  setSelectedImage: React.Dispatch<React.SetStateAction<string | undefined>>;
  setSelectedFilePath: React.Dispatch<React.SetStateAction<string | undefined>>;
  isEmpDataLoading: any;
  permissions: any;
  refreshEmployeeList: any;
  teamsList: TeamList[] | undefined;
  designationList: Designation[] | undefined;
  rolesList: Roles[] | undefined;
  enableSidePanel: boolean;
  employeeDetails: EmployeeType | undefined;
  setEnableSidePanel: React.Dispatch<React.SetStateAction<boolean>>;
  setEnableEmployeeEdit: React.Dispatch<React.SetStateAction<boolean>>;
  handleSidePanelClose: () => void;
  setSelectedEmployee: React.Dispatch<React.SetStateAction<string>>;
  role: string | undefined;
  assignees: AssigneeType[];
}) => {
  if (isEmpDataLoading) {
    return <DataLoading />;
  }

  const closeSidePanel = () => {
    setEnableSidePanel(false);
    setSelectedImage(undefined);
  };

  return (
    <div className={`tsk-vw-dtls ${enableSidePanel ? "show" : null}`}>
      <div className="modal-header">
        <div className="d-flex modal-title" id="">
          <p className="tsk-id">Member Details</p>
        </div>

        <div className="d-flex cpy-del-cls">
          {hasPermission(permissions, ["people:write"]) &&
            (!enableEmployeeEdit ? (
              <button
                className="d-flex outline-button team-btn btn-sm"
                type="button"
                onClick={() => setEnableEmployeeEdit(true)}
              >
                <span className="material-icons-outlined">edit</span>
                <p>Edit</p>
              </button>
            ) : (
              ""
            ))}
          <button>
            <span
              className="material-icons-round"
              onClick={() => closeSidePanel()}
            >
              close
            </span>
          </button>
        </div>
      </div>
      {employeeDetails ? (
        <EmployeeDetails
          selectFilePath={selectFilePath}
          setEnableSidePanel={setEnableSidePanel}
          myToast={myToast}
          hiddenFileInput={hiddenFileInput}
          employeeDataMutate={employeeDataMutate}
          enableEmployeeEdit={enableEmployeeEdit}
          setEnableEmployeeEdit={setEnableEmployeeEdit}
          refreshEmployeeList={refreshEmployeeList}
          rolesList={rolesList}
          teamsList={teamsList}
          selectImage={selectImage}
          setSelectedImage={setSelectedImage}
          setSelectedFilePath={setSelectedFilePath}
          designationList={designationList}
          details={employeeDetails}
          handleSidePanelClose={handleSidePanelClose}
          setSelectedEmployee={setSelectedEmployee}
          role={role}
          assignees={assignees}
        />
      ) : (
        ""
      )}
    </div>
  );
};

const EmployeeDetails = ({
  enableEmployeeEdit,
  selectFilePath,
  hiddenFileInput,
  setSelectedImage,
  setEnableSidePanel,
  selectImage,
  setSelectedFilePath,
  myToast,
  employeeDataMutate,
  setEnableEmployeeEdit,
  details,
  rolesList,
  teamsList,
  designationList,
  handleSidePanelClose,
  refreshEmployeeList,
  setSelectedEmployee,
  role,
  assignees,
}: {
  setEnableSidePanel: React.Dispatch<React.SetStateAction<boolean>>;
  selectFilePath: string | undefined;
  myToast: any;
  hiddenFileInput: any;
  selectImage: string | undefined;
  setSelectedImage: React.Dispatch<React.SetStateAction<string | undefined>>;
  setSelectedFilePath: React.Dispatch<React.SetStateAction<string | undefined>>;
  employeeDataMutate: any;
  refreshEmployeeList: any;
  enableEmployeeEdit: boolean;
  teamsList: TeamList[] | undefined;
  designationList: Designation[] | undefined;
  rolesList: Roles[] | undefined;
  details: EmployeeType;
  handleSidePanelClose: () => void;
  setEnableEmployeeEdit: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedEmployee: React.Dispatch<React.SetStateAction<string>>;
  role: string | undefined;
  assignees: AssigneeType[];
}) => {
  let employeeForm: EmployeeForm = {
    _id: details._id,
    profilepic: details.profilepic,
    first_name: details.profile.first_name,
    last_name: details.profile.last_name,
    training_video: details.profile.training_video,
    role: enableEmployeeEdit ? details.role?._id : details.role?.role_name,
    designation: enableEmployeeEdit
      ? details.designation?._id
      : details.designation?.name,
    department: enableEmployeeEdit
      ? details.department?._id
      : details.department?.name,
    reporting_to: enableEmployeeEdit
      ? details.reporting_to
      : details.reporting_to,
    type: details.type,
    skype_id: details.skype_id,
    date_of_birth: dateBeautify(details.date_of_birth),
    date_of_joining: dateBeautify(details.date_of_joining),
    email_id: details.profile.email_id,
    personal_emailId: details.personal_emailId,
    linkedIn_id: details.linkedIn_id,
    bank_details: details.bank_details,
    pan_number: details.pan_number,
    aadhar_number: details.aadhar_number,
    phonenumber: details.phonenumber,
    alternative_phonenumber: details.alternative_phonenumber,
    address: details.address,
    isactive_user: details.profile.isactive_user,
    gender: details.gender,
    father_name: details.father_name,
    mother_name: details.mother_name,
    marital_status: details.marital_status,
    esi_number: details.esi_number,
    uan_number: details.uan_number,
    employee_number: details.employee_number,
    casual_leave: details?.casual_leave,
    sick_leave: details?.sick_leave,
    privileged_leave: details?.privileged_leave,
    total_leave_allocated: details?.total_leave_allocated,
    total_leave_approved: details?.total_leave_approved,
  };

  const employeeFormValidation = Yup.object({
    profilepic: Yup.string(),
    first_name: Yup.string().required("*"),
    last_name: Yup.string().required("*"),
    training_video: Yup.string(),
    role: Yup.string().notOneOf(["select"]).required(),
    designation: Yup.string().notOneOf(["select"]).required(),
    department: Yup.string().required("*"),
    reporting_to: Yup.string(),
    type: Yup.string().required("*"),
    skype_id: Yup.string(),
    date_of_birth: Yup.string().required("*"),
    date_of_joining: Yup.string().required("*"),
    email_id: Yup.string()
      .matches(
        /^[A-Za-z0-9._%+-]+@solutionchamps.com$/g,
        "only solutionchamps domain is valid"
      )
      .required("*"),
    personal_emailId: Yup.string(),
    linkedIn_id: Yup.string(),
    bank_details: Yup.string(),
    pan_number: Yup.string(),
    aadhar_number: Yup.string(),
    phonenumber: Yup.string()
      .min(10, "Invalid phone number")
      .max(10, "Invalid phone number")
      .required("*"),
    alternative_phonenumber: Yup.string()
      .min(10, "Invalid phone number")
      .max(10, "Invalid phone number"),
    address: Yup.string(),
    gender: Yup.string().required("*"),
    father_name: Yup.string(),
    mother_name: Yup.string(),
    marital_status: Yup.string(),
    esi_number: Yup.string(),
    uan_number: Yup.string(),
    employee_number: Yup.string(),
  });

  return enableEmployeeEdit ? (
    <EditEmployeeDetails
      setEnableSidePanel={setEnableSidePanel}
      selectFilePath={selectFilePath}
      employeeId={details._id}
      myToast={myToast}
      hiddenFileInput={hiddenFileInput}
      setSelectedImage={setSelectedImage}
      selectImage={selectImage}
      setSelectedFilePath={setSelectedFilePath}
      employeeDataMutate={employeeDataMutate}
      rolesList={rolesList}
      setEnableEmployeeEdit={setEnableEmployeeEdit}
      teamsList={teamsList}
      designationList={designationList}
      employeeFormValidation={employeeFormValidation}
      employeeForm={employeeForm}
      refreshEmployeeList={refreshEmployeeList}
      handleSidePanelClose={handleSidePanelClose}
      setSelectedEmployee={setSelectedEmployee}
      role={role}
      assignees={assignees}
    />
  ) : (
    <ViewEmployeeDetails
      assignees={assignees}
      setEnableEmployeeEdit={setEnableEmployeeEdit}
      employeeForm={employeeForm}
      handleSidePanelClose={handleSidePanelClose}
      role={role}
    />
  );
};

const EditEmployeeDetails = ({
  employeeId,
  employeeDataMutate,
  myToast,
  setEnableSidePanel,
  selectFilePath,
  hiddenFileInput,
  setSelectedImage,
  selectImage,
  setSelectedFilePath,
  employeeForm,
  rolesList,
  setEnableEmployeeEdit,
  designationList,
  teamsList,
  refreshEmployeeList,
  employeeFormValidation,
  handleSidePanelClose,
  setSelectedEmployee,
  role,
  assignees,
}: {
  setEnableSidePanel: React.Dispatch<React.SetStateAction<boolean>>;
  selectFilePath: string | undefined;
  employeeId: string;
  myToast: any;
  employeeDataMutate: any;
  refreshEmployeeList: any;
  hiddenFileInput: any;
  selectImage: string | undefined;
  setSelectedImage: React.Dispatch<React.SetStateAction<string | undefined>>;
  setSelectedFilePath: React.Dispatch<React.SetStateAction<string | undefined>>;
  setEnableEmployeeEdit: React.Dispatch<React.SetStateAction<boolean>>;
  employeeFormValidation: any;
  teamsList: TeamList[] | undefined;
  designationList: Designation[] | undefined;
  rolesList: Roles[] | undefined;
  employeeForm: EmployeeForm;
  handleSidePanelClose: () => void;
  setSelectedEmployee: React.Dispatch<React.SetStateAction<string>>;
  role: string | undefined;
  assignees: AssigneeType[];
}) => {
  useEffect(() => {
    setSelectedImage(employeeForm.profilepic);
  }, []);
  const [hasShownWarning, setHasShownWarning] = useState(false);

  const [isConfirmToSubmit, setIsConfirmToSubmit] = useState(false);
  const [totalLeaveApproved, setTotalLeaveApproved] = useState(0);

  const showToast = (
    severityValue: string,
    summaryValue: string,
    detailValue: string
  ) => {
    myToast.current.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };

  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  const handleChange = async (event: any) => {
    const fileUploaded = event.target.files[0];
    let formData = new FormData();

    formData.append("file", fileUploaded);
    formData.append("intent", "userprofile");
    const result = await getImageFileUrl(formData);
    setSelectedImage(result.url);
    setSelectedFilePath(result.fileKey);
  };

  const handleEmployeeForm = async (values: EmployeeForm) => {
    try {
      // Check if the employee has worked for more than 5 years
      const hasFiveYears = hasWorkedMoreThanFiveYears(values?.date_of_joining);

      // Set default privileged leave and total leave allocated based on the tenure
      const updatedValues = {
        ...values,
        privileged_leave: hasFiveYears ? values?.privileged_leave ?? "0" : "0",
        total_leave_allocated: hasFiveYears ? "14" : "6",
        profilepic: selectFilePath,
      };

      // If the employee exists, update the employee data
      if (updatedValues && updatedValues._id) {
        const resp = await updateEmployee(updatedValues._id, updatedValues);
        if (resp.status === 200) {
          showToast(
            "success",
            "Success Message",
            "Employee Data was updated successfully."
          );
        }
      }

      // Refresh the employee data and UI
      employeeDataMutate();
      setSelectedImage(undefined);
      refreshEmployeeList();
    } catch (error) {
      console.log(error);
    }

    // Close the editing state and side panel
    setEnableEmployeeEdit(false);
    handleSidePanelClose();
  };

  const handleClickTrainingQueue = () => {
    setSelectedEmployee(employeeId);
    // setshowTrainingQueueModal(true)
  };

  const updateTotalLeaveApproved = (values: EmployeeForm) => {
    const newTotalLeaveApproved =
      (parseInt(values?.casual_leave || "0") || 0) +
      (parseInt(values?.sick_leave || "0") || 0) +
      (hasWorkedMoreThanFiveYears(values?.date_of_joining)
        ? parseInt(values?.privileged_leave || "0") || 0
        : 0);
    setTotalLeaveApproved(newTotalLeaveApproved);
  };

  const assgineesOptionTemplate = (option: any) => {
    return (
      <div className="d-flex sm-user-name">
        {/* { option.profilepic ? <img src={option.profilepic} />: <img src={defaultpicture} />} */}
        <DefaultImage
          src={option.profilepic}
          alt=""
          className=""
          letter={option.name[0]}
        />
        <div>{option.name}</div>
      </div>
    );
  };

  const selectedAssgineesTemplate = (option: any, props: any) => {
    if (option) {
      return (
        <div className="d-flex sm-user-name">
          {/* { option.profilepic ? <img src={option.profilepic} />: <img src={defaultpicture} />} */}
          <DefaultImage
            src={option.profilepic}
            alt=""
            className=""
            letter={option.name[0]}
          />
          <div>{option.name}</div>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  // Function to calculate if the employee has worked more than 5 years
  const hasWorkedMoreThanFiveYears = (dateOfJoining: string) => {
    const currentDate = new Date();
    const joiningDate = new Date(dateOfJoining);

    // Calculate the difference in years, months, and days
    let yearsDifference = currentDate.getFullYear() - joiningDate.getFullYear();
    let monthsDifference = currentDate.getMonth() - joiningDate.getMonth();
    let daysDifference = currentDate.getDate() - joiningDate.getDate();

    // Adjust for negative months
    if (monthsDifference < 0) {
      yearsDifference--;
      monthsDifference += 12;
    }

    // Adjust for negative days
    if (daysDifference < 0) {
      monthsDifference--;
      // Get the number of days in the previous month
      const previousMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        0
      ).getDate();
      daysDifference += previousMonth;

      // If adjusting days resulted in negative months, adjust the year
      if (monthsDifference < 0) {
        yearsDifference--;
        monthsDifference += 12;
      }
    }

    // Final check: Has the employee worked more than 5 years?
    return yearsDifference >= 5;
  };
  useEffect(() => {
    if (hasShownWarning) {
      showToast("warn", "Warning", "Kindly fill the required fields!");
    }
  }, [hasShownWarning]);
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={employeeForm}
        validationSchema={employeeFormValidation}
        onSubmit={handleEmployeeForm}
      >
        {({ errors, touched, isSubmitting, values, setFieldValue }) => {
          if (Object.keys(errors).length > 0 && isSubmitting) {
            setHasShownWarning(true);
            updateTotalLeaveApproved(values);
          } else {
            setHasShownWarning(false);
          }
          return (
            <Form className="d-flex-grow-1">
              <div className="modal-content active-edit-member-details">
                <div className="modal-body member-details-body">
                  <div className="modal-body-inner">
                    <div className="team-user-image">
                      <div className="team-user-image-inner">
                        <button
                          className="d-flex add-time"
                          type="button"
                          onClick={() => handleClick()}
                        >
                          <span className="material-icons-outlined">
                            photo_camera
                          </span>
                        </button>
                        <img src={selectImage} alt="" />
                        <input
                          type="file"
                          ref={hiddenFileInput}
                          onChange={handleChange}
                          style={{ display: "none" }}
                        />
                      </div>
                    </div>
                    <div className="lst-tsk-nm">
                      <div className="dtls-update">
                        <div className="d-flex list-headings">
                          <p className="d-flex">EMPLOYEE NUMBER</p>
                          <div className="drpdwn-slct">
                            <Field name="employee_number" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="lst-tsk-nm">
                      <div className="dtls-update">
                        <div className="d-flex list-headings">
                          <p className="d-flex">
                            FIRST NAME
                            {errors.first_name && touched.first_name ? (
                              <span style={{ color: "red" }}>*</span>
                            ) : null}
                          </p>
                          <div className="drpdwn-slct">
                            <Field name="first_name" />
                          </div>
                        </div>
                        <div className="d-flex list-headings">
                          <p className="d-flex">
                            LAST NAME
                            {errors.last_name && touched.last_name ? (
                              <span style={{ color: "red" }}>*</span>
                            ) : null}
                          </p>
                          <div className="drpdwn-slct">
                            <Field name="last_name" />
                          </div>
                        </div>

                        <div className="d-flex list-headings">
                          <p className="d-flex">
                            GENDER
                            {errors.gender && touched.gender ? (
                              <span style={{ color: "red" }}>*</span>
                            ) : null}
                          </p>
                          <div className="drpdwn-slct">
                            <Field name="gender">
                              {({ field }: { field: any }) => (
                                <select {...field} name="gender">
                                  <option value="">Select</option>
                                  <option value="Male"> Male </option>
                                  <option value="Female"> Female </option>
                                  <option value="Others"> Others </option>
                                </select>
                              )}
                            </Field>
                          </div>
                        </div>

                        <div className="d-flex list-headings">
                          <p className="d-flex">MARITAL STATUS</p>
                          <div className="drpdwn-slct">
                            <Field name="marital_status">
                              {({ field }: { field: any }) => (
                                <select {...field} name="marital_status">
                                  <option value="">Select</option>
                                  <option value="Single"> Single </option>
                                  <option value="Married"> Married </option>
                                </select>
                              )}
                            </Field>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="point-details">
                      <div className="pro-name">Family Details</div>
                      <div className="lst-tsk-nm">
                        <div className="dtls-update">
                          <div className="d-flex list-headings">
                            <p className="d-flex">FATHER NAME</p>
                            <div className="drpdwn-slct">
                              <Field name="father_name" />
                            </div>
                          </div>
                          <div className="d-flex list-headings">
                            <p className="d-flex">MOTHER NAME </p>
                            <div className="drpdwn-slct">
                              <Field name="mother_name" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="point-details">
                      <div className="pro-name">General Details</div>
                      <div className="lst-tsk-nm">
                        <div className="dtls-update">
                          <div className="d-flex list-headings">
                            <p className="d-flex">
                              ROLE
                              {errors.role && touched.role ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : null}
                            </p>
                            <div className="drpdwn-slct">
                              <Field name="role">
                                {({ field }: { field: any }) => (
                                  <select {...field} name="role">
                                    {rolesList?.map((item, index) => (
                                      <option key={index} value={item._id}>
                                        {item.role_name}
                                      </option>
                                    ))}
                                  </select>
                                )}
                              </Field>
                            </div>
                          </div>
                          <div className="d-flex list-headings">
                            <p className="d-flex">
                              DESIGNATION
                              {errors.designation && touched.designation ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : null}
                            </p>
                            <div className="drpdwn-slct">
                              <Field name="designation">
                                {({ field }: { field: any }) => (
                                  <select {...field} name="designation">
                                    {designationList?.map((item, index) => (
                                      <option key={index} value={item._id}>
                                        {item.name}
                                      </option>
                                    ))}
                                  </select>
                                )}
                              </Field>
                            </div>
                          </div>
                          <div className="d-flex list-headings">
                            <p className="d-flex">
                              DEPARTMENT
                              {errors.department && touched.department ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : null}
                            </p>
                            <div className="drpdwn-slct">
                              <Field name="department">
                                {({ field }: { field: any }) => (
                                  <select {...field} name="department" disabled>
                                    {teamsList?.map((item, index) => (
                                      <option key={index} value={item._id}>
                                        {item.name}
                                      </option>
                                    ))}
                                  </select>
                                )}
                              </Field>
                            </div>
                          </div>

                          <div className="d-flex list-headings">
                            <p className="d-flex">REPORTING_TO</p>
                            <div className="drpdwn-slct">
                              <Field name="reporting_to">
                                {({ field }: { field: any }) => {
                                  return (
                                    <Dropdown
                                      name="reporting_to"
                                      optionLabel="name"
                                      optionValue="_id"
                                      value={field.value}
                                      onChange={field.onChange}
                                      options={assignees}
                                      itemTemplate={assgineesOptionTemplate}
                                      valueTemplate={selectedAssgineesTemplate}
                                      placeholder="Select"
                                    />
                                  );
                                }}
                              </Field>
                            </div>
                          </div>

                          <div className="d-flex list-headings">
                            <p className="d-flex">
                              EMPLOYEE TYPE
                              {errors.type && touched.type ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : null}
                            </p>
                            <div className="drpdwn-slct">
                              <Field name="type">
                                {({ field }: { field: any }) => (
                                  <select {...field} name="type">
                                    <option value="Probation">
                                      {" "}
                                      Probation{" "}
                                    </option>
                                    <option value="Freelancer">
                                      {" "}
                                      Freelancer{" "}
                                    </option>
                                    <option value="Permanent">
                                      {" "}
                                      Permanent{" "}
                                    </option>
                                    <option value="Contract"> Contract </option>
                                  </select>
                                )}
                              </Field>
                            </div>
                          </div>
                          <div className="d-flex list-headings">
                            <p className="d-flex">SKYPE ID</p>
                            <div className="drpdwn-slct">
                              <Field name="skype_id" />
                            </div>
                          </div>
                          <div className="d-flex list-headings">
                            <p className="d-flex">LINKEDIN ID </p>
                            <div className="drpdwn-slct">
                              <Field name="linkedIn_id" />
                            </div>
                          </div>

                          {role == "SuperAdmin" ? (
                            <div className="d-flex list-headings">
                              <p className="d-flex">PAN NUMBER </p>
                              <div className="drpdwn-slct">
                                <Field name="pan_number" />
                              </div>
                            </div>
                          ) : null}

                          {role == "SuperAdmin" ? (
                            <div className="d-flex list-headings">
                              <p className="d-flex">AADHAR NUMBER</p>
                              <div className="drpdwn-slct">
                                <Field name="aadhar_number" />
                              </div>
                            </div>
                          ) : null}

                          {role == "SuperAdmin" ? (
                            <div className="d-flex list-headings">
                              <p className="d-flex">ESI NUMBER </p>
                              <div className="drpdwn-slct">
                                <Field name="esi_number" />
                              </div>
                            </div>
                          ) : null}

                          {role == "SuperAdmin" ? (
                            <div className="d-flex list-headings">
                              <p className="d-flex">UAN NUMBER </p>
                              <div className="drpdwn-slct">
                                <Field name="uan_number" />
                              </div>
                            </div>
                          ) : null}

                          <div className="d-flex list-headings">
                            <p className="d-flex">
                              DATE OF BIRTH
                              {errors.date_of_birth && touched.date_of_birth ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : null}
                            </p>
                            <div className="drpdwn-slct">
                              <Field name="date_of_birth">
                                {({ field }: { field: any }) => {
                                  return (
                                    <Calendar
                                      name="date_of_birth"
                                      value={new Date(field.value)}
                                      onChange={field.onChange}
                                      showIcon
                                      icon={"pi pi-calendar"}
                                      monthNavigator
                                      yearNavigator
                                      yearRange="1900:2200"
                                      maxDate={new Date()}
                                    />
                                  );
                                }}
                              </Field>
                            </div>
                          </div>
                          <div className="d-flex list-headings">
                            <p className="d-flex">
                              DATE OF JOINING
                              {errors.date_of_joining &&
                              touched.date_of_joining ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : null}
                            </p>
                            <div className="drpdwn-slct">
                              <Field name="date_of_joining">
                                {({ field }: { field: any }) => {
                                  return (
                                    <Calendar
                                      name="date_of_joining"
                                      value={new Date(field.value)}
                                      onChange={field.onChange}
                                      showIcon
                                      icon={"pi pi-calendar"}
                                      monthNavigator
                                      yearNavigator
                                      yearRange="1900:2200"
                                    />
                                  );
                                }}
                              </Field>
                              <ErrorMessage name="date_of_joining" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="point-details">
                      <div className="pro-name">Contact Details</div>
                      <div className="lst-tsk-nm">
                        <div className="dtls-update">
                          <div className="d-flex list-headings">
                            <p className="d-flex">
                              EMAIL
                              {errors.email_id && touched.email_id ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : null}
                            </p>
                            <div className="drpdwn-slct">
                              <Field name="email_id" />
                              <ErrorMessage name="email_id" />
                            </div>
                          </div>

                          <div className="d-flex list-headings">
                            <p className="d-flex">PERSONAL EMAIL </p>
                            <div className="drpdwn-slct">
                              <Field name="personal_emailId" />
                            </div>
                          </div>

                          <div className="d-flex list-headings">
                            <p className="d-flex">
                              PHONE NO
                              {errors.phonenumber && touched.phonenumber ? (
                                <span style={{ color: "red" }}>*</span>
                              ) : null}
                            </p>
                            <div className="drpdwn-slct">
                              <Field name="phonenumber" />
                              <ErrorMessage name="phonenumber" />
                            </div>
                          </div>

                          <div className="d-flex list-headings">
                            <p className="d-flex">ALTERNATE PHONE NO</p>
                            <div className="drpdwn-slct">
                              <Field name="alternative_phonenumber" />
                              <ErrorMessage name="alternative_phonenumber" />
                            </div>
                          </div>

                          <div className="d-flex list-headings">
                            <p className="d-flex">ADDRESS</p>
                            <div className="drpdwn-slct">
                              <Field name="address" as="textarea" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {role == "SuperAdmin" ? (
                      <div className="point-details">
                        <div className="pro-name">Bank Details</div>
                        <div className="lst-tsk-nm">
                          <div className="dtls-update">
                            <div className="d-flex list-headings">
                              <p className="d-flex"> DETAILS</p>
                              <div className="drpdwn-slct">
                                <Field name="bank_details" as="textarea" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}

                    <div className="point-details">
                      <div className="pro-name">Leave Policy Details</div>
                      <div className="lst-tsk-nm">
                        <div className="dtls-update">
                          <div className="d-flex list-headings">
                            <p className="d-flex">CASUAL LEAVE</p>
                            <div className="drpdwn-slct">
                              <Field
                                name="casual_leave"
                                value={values.casual_leave ?? 0}
                              />
                              <ErrorMessage name="casual_leave" />
                            </div>
                          </div>
                          <div className="d-flex list-headings">
                            <p className="d-flex">SICK LEAVE</p>
                            <div className="drpdwn-slct">
                              <Field
                                name="sick_leave"
                                value={values.sick_leave ?? 0}
                              />
                              <ErrorMessage name="sick_leave" />
                            </div>
                          </div>
                          {hasWorkedMoreThanFiveYears(
                            values?.date_of_joining
                          ) && (
                            <div className="d-flex list-headings">
                              <p className="d-flex">PRIVILEGED LEAVE</p>
                              <div className="drpdwn-slct">
                                <Field
                                  name="privileged_leave"
                                  value={values.privileged_leave ?? 0}
                                />
                                <ErrorMessage name="privileged_leave" />
                              </div>
                            </div>
                          )}

                          <div className="d-flex list-headings">
                            <p className="d-flex">TOTAL LEAVE ALLOCATED</p>
                            <div className="drpdwn-slct">
                              {hasWorkedMoreThanFiveYears(
                                values?.date_of_joining
                              ) ? (
                                <Field
                                  name="total_leave_allocated"
                                  value={values.total_leave_allocated ?? 14}
                                  readOnly
                                />
                              ) : (
                                <Field
                                  name="total_leave_allocated"
                                  value={values.total_leave_allocated ?? 6}
                                  readOnly
                                />
                              )}
                              <ErrorMessage name="total_leave_allocated" />
                            </div>
                          </div>
                          <div className="d-flex list-headings">
                            <p className="d-flex">LEAVE TAKEN</p>
                            <div className="drpdwn-slct">
                              <Field
                                name="total_leave_approved"
                                value={totalLeaveApproved ?? 0}
                                readOnly
                              />
                              <ErrorMessage name="total_leave_approved" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <div>
                    <Button
                      className="btn delete delete-full-btn"
                      onClick={() =>
                        confirmDeleteEmployee(
                          employeeId,
                          setSelectedImage,
                          setEnableSidePanel,
                          handleSidePanelClose,
                          setEnableEmployeeEdit,
                          refreshEmployeeList,
                          myToast
                        )
                      }
                      label="Delete"
                    ></Button>
                  </div>
                  <div className="d-flex">
                    <button
                      type="button"
                      className="btn cancel"
                      data-bs-dismiss="modal"
                      onClick={() =>
                        cancelEmployeeEdit(
                          setSelectedImage,
                          setEnableEmployeeEdit,
                          handleSidePanelClose
                        )
                      }
                    >
                      Cancel
                    </button>
                    {/* <Button type="button" onClick={() => confirmEdit(handleSidePanelClose, values)} label="Save"></Button> */}
                    <button
                      type="submit"
                      className="btn save"
                      disabled={isSubmitting}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

const cancelEmployeeEdit = (
  setSelectedImage: React.Dispatch<React.SetStateAction<string | undefined>>,
  setEnableEmployeeEdit: React.Dispatch<React.SetStateAction<boolean>>,
  handleSidePanelClose: () => void
) => {
  setEnableEmployeeEdit(false);
  setSelectedImage(undefined);
  handleSidePanelClose();
};

const ViewEmployeeDetails = ({
  assignees,
  employeeForm,
  handleSidePanelClose,
  setEnableEmployeeEdit,
  role,
}: {
  assignees: AssigneeType[];
  employeeForm: EmployeeForm;
  handleSidePanelClose: () => void;
  setEnableEmployeeEdit: React.Dispatch<React.SetStateAction<boolean>>;
  role: string | undefined;
}) => {
  const handleEmployeeForm = async () => {
    handleSidePanelClose();
    setEnableEmployeeEdit(false);
  };

  const assgineesOptionTemplate = (option: any) => {
    return (
      <div className="d-flex sm-user-name">
        {/* { option.profilepic ? <img src={option.profilepic} />: <img src={defaultpicture} />} */}
        <DefaultImage
          src={option.profilepic}
          alt=""
          className=""
          letter={option.name[0]}
        />
        <div>{option.name}</div>
      </div>
    );
  };

  const selectedAssgineesTemplate = (option: any, props: any) => {
    if (option) {
      return (
        <div className="d-flex sm-user-name">
          {/* { option.profilepic ? <img src={option.profilepic} />: <img src={defaultpicture} />} */}
          <DefaultImage
            src={option.profilepic}
            alt=""
            className=""
            letter={option.name[0]}
          />
          <div>{option.name}</div>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  // Function to calculate if the employee has worked more than 5 years
  const hasWorkedMoreThanFiveYears = (dateOfJoining: string) => {
    const currentDate = new Date();
    const joiningDate = new Date(dateOfJoining);

    // Calculate the difference in years, months, and days
    let yearsDifference = currentDate.getFullYear() - joiningDate.getFullYear();
    let monthsDifference = currentDate.getMonth() - joiningDate.getMonth();
    let daysDifference = currentDate.getDate() - joiningDate.getDate();

    // Adjust for negative months
    if (monthsDifference < 0) {
      yearsDifference--;
      monthsDifference += 12;
    }

    // Adjust for negative days
    if (daysDifference < 0) {
      monthsDifference--;
      // Get the number of days in the previous month
      const previousMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        0
      ).getDate();
      daysDifference += previousMonth;

      // If adjusting days resulted in negative months, adjust the year
      if (monthsDifference < 0) {
        yearsDifference--;
        monthsDifference += 12;
      }
    }

    // Final check: Has the employee worked more than 5 years?
    return yearsDifference >= 5;
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={employeeForm}
        onSubmit={handleEmployeeForm}
      >
        {({ values }) => {
          return (
            <Form className="d-flex-grow-1">
              <div className="modal-content active-edit-member-details">
                <div className="modal-body member-details-body">
                  <div className="modal-body-inner">
                    <div className="team-user-image">
                      {employeeForm.profilepic ? (
                        <div className="team-user-image-inner">
                          {/* <img src={employeeForm.profilepic} alt="" /> */}
                          <DefaultImage
                            src={employeeForm.profilepic}
                            alt=""
                            className=""
                            letter={employeeForm.first_name[0]}
                          />
                        </div>
                      ) : (
                        <div className="team-user-image-inner">
                          {/* <img src={defaultpicture} alt="" /> */}
                          <DefaultImage
                            src={employeeForm.profilepic}
                            alt=""
                            className=""
                            letter={employeeForm.first_name[0]}
                          />
                        </div>
                      )}
                    </div>

                    <div className="lst-tsk-nm">
                      <div className="dtls-update">
                        <div className="d-flex list-headings">
                          <p className="d-flex">EMPLOYEE NUMBER</p>
                          <div className="drpdwn-slct">
                            <Field name="employee_number" readOnly />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="lst-tsk-nm">
                      <div className="dtls-update">
                        <div className="d-flex list-headings">
                          <p className="d-flex">FIRST NAME</p>
                          <div className="drpdwn-slct">
                            <Field name="first_name" readOnly />
                          </div>
                        </div>
                        <div className="d-flex list-headings">
                          <p className="d-flex">LAST NAME</p>
                          <div className="drpdwn-slct">
                            <Field name="last_name" readOnly />
                          </div>
                        </div>
                        <div className="d-flex list-headings">
                          <p className="d-flex">GENDER</p>
                          <div className="drpdwn-slct">
                            <Field name="gender" readOnly />
                          </div>
                        </div>
                        <div className="d-flex list-headings">
                          <p className="d-flex">MARITAL STATUS</p>
                          <div className="drpdwn-slct">
                            <Field name="marital_status" readOnly />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="point-details">
                      <div className="pro-name">Family Details</div>
                      <div className="lst-tsk-nm">
                        <div className="dtls-update">
                          <div className="d-flex list-headings">
                            <p className="d-flex">FATHER NAME</p>
                            <div className="drpdwn-slct">
                              <Field name="father_name" readOnly />
                            </div>
                          </div>

                          <div className="d-flex list-headings">
                            <p className="d-flex">MOTHER NAME</p>
                            <div className="drpdwn-slct">
                              <Field name="mother_name" readOnly />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="point-details">
                      <div className="pro-name">General Details</div>
                      <div className="lst-tsk-nm">
                        <div className="dtls-update">
                          <div className="d-flex list-headings">
                            <p className="d-flex">ROLE</p>
                            <div className="drpdwn-slct">
                              <Field name="role" readOnly />
                            </div>
                          </div>
                          <div className="d-flex list-headings">
                            <p className="d-flex">DESIGNATION</p>
                            <div className="drpdwn-slct">
                              <Field name="designation" readOnly />
                            </div>
                          </div>
                          <div className="d-flex list-headings">
                            <p className="d-flex">DEPARTMENT</p>
                            <div className="drpdwn-slct">
                              <Field name="department" readOnly />
                            </div>
                          </div>

                          <div className="d-flex list-headings">
                            <p className="d-flex">REPORTING_TO</p>
                            <div className="drpdwn-slct">
                              <Field name="reporting_to">
                                {({ field }: { field: any }) => {
                                  return (
                                    <Dropdown
                                      name="reporting_to"
                                      optionLabel="name"
                                      optionValue="_id"
                                      value={field.value}
                                      onChange={field.onChange}
                                      options={assignees}
                                      itemTemplate={assgineesOptionTemplate}
                                      valueTemplate={selectedAssgineesTemplate}
                                      placeholder="Select"
                                      disabled
                                    />
                                  );
                                }}
                              </Field>
                            </div>
                          </div>
                          <div className="d-flex list-headings">
                            <p className="d-flex">EMPLOYEE TYPE</p>
                            <div className="drpdwn-slct">
                              <Field name="type" readOnly />
                            </div>
                          </div>
                          <div className="d-flex list-headings">
                            <p className="d-flex">SKYPE ID</p>
                            <div className="drpdwn-slct">
                              <Field name="skype_id" readOnly />
                            </div>
                          </div>
                          <div className="d-flex list-headings">
                            <p className="d-flex">LINKEDIN ID</p>
                            <div className="drpdwn-slct">
                              <Field name="linkedIn_id" readOnly />
                            </div>
                          </div>
                          {role == "SuperAdmin" ? (
                            <div className="d-flex list-headings">
                              <p className="d-flex">PAN NUMBER</p>
                              <div className="drpdwn-slct">
                                <Field name="pan_number" readOnly />
                              </div>
                            </div>
                          ) : null}
                          {role == "SuperAdmin" ? (
                            <div className="d-flex list-headings">
                              <p className="d-flex">AADHAR NUMBER</p>
                              <div className="drpdwn-slct">
                                <Field name="aadhar_number" readOnly />
                              </div>
                            </div>
                          ) : null}

                          {role == "SuperAdmin" ? (
                            <div className="d-flex list-headings">
                              <p className="d-flex">ESI NUMBER </p>
                              <div className="drpdwn-slct">
                                <Field name="esi_number" readOnly />
                              </div>
                            </div>
                          ) : null}

                          {role == "SuperAdmin" ? (
                            <div className="d-flex list-headings">
                              <p className="d-flex">UAN NUMBER </p>
                              <div className="drpdwn-slct">
                                <Field name="uan_number" readOnly />
                              </div>
                            </div>
                          ) : null}
                          {role == "Contributor" ? (
                            <div className="d-flex list-headings">
                              <p className="d-flex">DATE OF BIRTH</p>
                              <div className="drpdwn-slct">
                                <p>******</p>
                              </div>
                            </div>
                          ) : (
                            <div className="d-flex list-headings">
                              <p className="d-flex">DATE OF BIRTH</p>
                              <div className="drpdwn-slct">
                                <Field name="date_of_birth" readOnly />
                              </div>
                            </div>
                          )}
                          {role == "Contributor" ? (
                            <div className="d-flex list-headings">
                              <p className="d-flex">DATE OF JOINING</p>
                              <div className="drpdwn-slct">
                                <p>******</p>
                              </div>
                            </div>
                          ) : (
                            <div className="d-flex list-headings">
                              <p className="d-flex">DATE OF JOINING</p>
                              <div className="drpdwn-slct">
                                <Field name="date_of_joining" readOnly />
                                <ErrorMessage name="date_of_joining" />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="point-details">
                      <div className="pro-name">Contact Details</div>
                      <div className="lst-tsk-nm">
                        <div className="dtls-update">
                          <div className="d-flex list-headings">
                            <p className="d-flex">EMAIL</p>
                            <div className="drpdwn-slct">
                              <Field name="email_id" readOnly />
                              <ErrorMessage name="email_id" />
                            </div>
                          </div>
                          <div className="d-flex list-headings">
                            <p className="d-flex">PERSONAL EMAIL</p>
                            <div className="drpdwn-slct">
                              <Field name="personal_emailId" readOnly />
                            </div>
                          </div>

                          {role == "Contributor" ? (
                            <div className="d-flex list-headings">
                              <p className="d-flex">PHONE NO</p>
                              <div className="drpdwn-slct">
                                <p>******</p>
                              </div>
                            </div>
                          ) : (
                            <div className="d-flex list-headings">
                              <p className="d-flex">PHONE NO</p>
                              <div className="drpdwn-slct">
                                <Field name="phonenumber" readOnly />
                                <ErrorMessage name="phonenumber" />
                              </div>
                            </div>
                          )}

                          {role == "Contributor" ? (
                            <div className="d-flex list-headings">
                              <p className="d-flex">ALTERNATE PHONE NO</p>
                              <div className="drpdwn-slct">
                                <p>******</p>
                              </div>
                            </div>
                          ) : (
                            <div className="d-flex list-headings">
                              <p className="d-flex">ALTERNATE PHONE NO</p>
                              <div className="drpdwn-slct">
                                <Field
                                  name="alternative_phonenumber"
                                  readOnly
                                />
                                <ErrorMessage name="alternative_phonenumber" />
                              </div>
                            </div>
                          )}

                          {role == "Contributor" ? (
                            <div className="d-flex list-headings">
                              <p className="d-flex">ADDRESS</p>
                              <div className="drpdwn-slct">
                                <p>******</p>
                              </div>
                            </div>
                          ) : (
                            <div className="d-flex list-headings">
                              <p className="d-flex">ADDRESS</p>
                              <div className="drpdwn-slct">
                                <Field name="address" as="textarea" readOnly />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="point-details">
                      <div className="pro-name">Leave Policy Details</div>
                      <div className="lst-tsk-nm">
                        <div className="dtls-update">
                          <div className="d-flex list-headings">
                            <p className="d-flex">CASUAL LEAVE</p>
                            <div className="drpdwn-slct">
                              <Field
                                name="casual_leave"
                                readOnly
                                value={values.casual_leave ?? 0} // Set default value to 0 if undefined
                              />
                              <ErrorMessage name="casual_leave" />
                            </div>
                          </div>
                          <div className="d-flex list-headings">
                            <p className="d-flex">SICK LEAVE</p>
                            <div className="drpdwn-slct">
                              <Field
                                name="sick_leave"
                                readOnly
                                value={values.sick_leave ?? 0}
                              />
                              <ErrorMessage name="sick_leave" />
                            </div>
                          </div>
                          {hasWorkedMoreThanFiveYears(
                            values?.date_of_joining
                          ) && (
                            <div className="d-flex list-headings">
                              <p className="d-flex">PRIVILEGED LEAVE</p>
                              <div className="drpdwn-slct">
                                <Field
                                  name="privileged_leave"
                                  value={values.privileged_leave ?? 0}
                                  readOnly
                                />
                                <ErrorMessage name="privileged_leave" />
                              </div>
                            </div>
                          )}
                          <div className="d-flex list-headings">
                            <p className="d-flex">TOTAL LEAVE ALLOCATED</p>
                            <div className="drpdwn-slct">
                              {hasWorkedMoreThanFiveYears(
                                values?.date_of_joining
                              ) ? (
                                <Field
                                  name="total_leave_allocated"
                                  value={values.total_leave_allocated ?? 14}
                                  readOnly
                                />
                              ) : (
                                <Field
                                  name="total_leave_allocated"
                                  value={values.total_leave_allocated ?? 6}
                                  readOnly
                                />
                              )}
                              <ErrorMessage name="total_leave_allocated" />
                            </div>
                          </div>
                          <div className="d-flex list-headings">
                            <p className="d-flex">LEAVE TAKEN</p>
                            <div className="drpdwn-slct">
                              <Field
                                name="total_leave_approved"
                                value={values.total_leave_approved ?? 0}
                                readOnly
                              />
                              <ErrorMessage name="total_leave_approved" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

const confirmDeleteEmployee = (
  employeeId: string,
  setSelectedImage: React.Dispatch<React.SetStateAction<string | undefined>>,
  setEnableSidePanel: React.Dispatch<React.SetStateAction<boolean>>,
  handleSidePanelClose: () => void,
  setEnableEmployeeEdit: React.Dispatch<React.SetStateAction<boolean>>,
  refreshEmployeeList: any,
  myToast: any
) => {
  confirmDialog({
    message: "Do you want to delete this record?",
    header: "Confirmation",
    className: "mini-alert-popup-ui",
    icon: "pi pi-exclamation-circle",
    accept: () =>
      deleteMember(
        employeeId,
        handleSidePanelClose,
        refreshEmployeeList,
        myToast
      ),
    reject: () => setEnableSidePanel(true),
  });
  setEnableEmployeeEdit(false);

  const deleteMember = async (
    employeeId: string,
    handleSidePanelClose: () => void,
    refreshEmployeeList: any,
    myToast: any
  ) => {
    const showToast = (
      severityValue: string,
      summaryValue: string,
      detailValue: string
    ) => {
      myToast.current.show({
        severity: severityValue,
        summary: summaryValue,
        detail: detailValue,
      });
    };
    try {
      const result = await deleteEmployee(employeeId);
      if (result.status === 200) {
        showToast(
          "success",
          "Success Message",
          "Employee was deleted successfully."
        );
      }
    } catch (error) {
      showToast("warn", "Warning", "User already exists in some projects!");
      console.log(error);
    }
    refreshEmployeeList();
    setSelectedImage(undefined);
    handleSidePanelClose();
  };
};

function Team() {
  const [selectedTeam, setSelectedTeam] = useState<string>("All");
  const [selectedReportingPerson, setSelectedReportingPerson] =
    useState<string>("");
  const [selectedTeamName, setSelectedTeamName] = useState<string>("All");
  const [employeeSortList, setEmployeeSortList] = useState<
    Employees[] | undefined
  >();
  const [rolesData, setRolesData] = useState<string>("All");
  const [totalMembers, setTotalMembers] = useState<number>(0);
  const [selectSortName, setSortedName] = useState<string>("asce");

  const [showTeamModal, setTeamShow] = useState(false);
  const handleTeamClose = () => setTeamShow(false);
  const handleTeamShow = () => setTeamShow(true);

  const [showEmployeeModal, setEmployeeShow] = useState(false);
  const handleEmployeeClose = () => setEmployeeShow(false);

  const { teamsList, isLoading, mutate } = useTeamsList();

  const { rolesList } = useRolesList();

  const { designationList } = useDesignationList();

  const { employeeNumber } = useEmployeeNumber();

  const { employeesList, isEmployeesLoading, employeeListMutate } =
    useEmployeeList(selectedTeam, rolesData);

  const { teamsDetails, teamMutate } = useTeamDetails(selectedTeam);

  const { assignees } = useAssigneeList();

  const [isTeamUpdate, setIsTeamUpdate] = useState(false);
  const [isVideoUpdate, setIsVideoUpdate] = useState(false);

  useEffect(() => {
    if (teamsList) {
      setSelectedTeam(teamsList[0]?._id);
      setSelectedTeamName(teamsList[0]?.name);
      employeeListMutate();
      teamMutate();
    }
  }, []);

  useEffect(() => {
    _getPermissions();
  }, []);

  let teamForm: TeamForm = {
    _id: "",
    name: "",
    manager: null,
    description: null,
    work_schedule: null,
  };
  const [teamFields, setTeamFields] = useState(teamForm);

  const [selectImage, setSelectedImage] = useState<string | undefined>();

  const [selectVideo, setSelectedVideo] = useState<string | undefined>();

  const [selectFilePath, setSelectedFilePath] = useState<string | undefined>();

  const [enableSidePanel, setEnableSidePanel] = useState(false);

  const [enableEmployeeEdit, setEnableEmployeeEdit] = useState(false);

  const [selectedEmployee, setSelectedEmployee] = useState("");

  const { employeeDetails, isEmpDataLoading, employeeDataMutate } =
    useEmployeeDetails(selectedEmployee);

  const handleSidePanelClose = () => setEnableSidePanel(false);

  const myToast = useRef(null);

  const hiddenFileInput = useRef(null);

  const [permissions, setPermissions] = useState<string[]>([]);

  const [role, setRole] = useState<string>();

  const _getPermissions = async () => {
    let token = await getPermissionsList();
    setPermissions(token.permissions);
    setRole(token.login_user.role_name);
  };

  // Close side panel when the selected team name changes
  useEffect(() => {
    if (enableSidePanel) {
      setEnableSidePanel(false);
    }
  }, [selectedTeamName]); // Dependency array listening to team name changes

  return (
    <>
      <TeamSidePanel
        teamsList={teamsList}
        isLoading={isLoading}
        employeeListMutate={employeeListMutate}
        selectedTeam={setSelectedTeam}
        selectedTeamName={setSelectedTeamName}
        teamId={selectedTeam}
        setshowTeamModal={setTeamShow}
        setIsTeamUpdate={setIsTeamUpdate}
        setTeamFields={setTeamFields}
        permissions={permissions}
        setSortedName={setSortedName}
        setRolesData={setRolesData}
        teamMutate={teamMutate}
        setSelectedReportingPerson={setSelectedReportingPerson}
      />

      <Toast ref={myToast} />

      <EmployeeTableList
        isEmployeesLoading={isEmployeesLoading}
        employeeListMutate={employeeListMutate}
        selectSortName={selectSortName}
        setSortedName={setSortedName}
        employeesList={employeesList}
        selectedTeamName={selectedTeamName}
        totalMembers={totalMembers}
        setTotalMembers={setTotalMembers}
        rolesList={rolesList}
        rolesData={rolesData}
        setRolesData={setRolesData}
        setshowTeamModal={setTeamShow}
        setEmployeeSortList={setEmployeeSortList}
        setIsTeamUpdate={setIsTeamUpdate}
        setEmployeeModal={setEmployeeShow}
        selectedTeam={selectedTeam}
        teamDetails={teamsDetails}
        setTeamFields={setTeamFields}
        enableSidePanel={setEnableSidePanel}
        selectedEmployee={selectedEmployee}
        setSelectedEmployee={setSelectedEmployee}
        permissions={permissions}
        employeeDetails={employeeDetails}
        myToast={myToast}
      />

      <TeamModal
        myToast={myToast}
        employeeListMutate={employeeListMutate}
        isTeamUpdate={isTeamUpdate}
        assignees={assignees}
        handleTeamShow={handleTeamShow}
        showTeamModal={showTeamModal}
        handleTeamClose={handleTeamClose}
        employeesList={employeesList}
        setSelectedTeam={setSelectedTeam}
        teamMutate={teamMutate}
        setSelectedTeamName={setSelectedTeamName}
        teamFields={teamFields}
        refreshTaskList={mutate}
      />

      <EmployeeModal
        selectFilePath={selectFilePath}
        teamMutate={teamMutate}
        setSelectedFilePath={setSelectedFilePath}
        selectImage={selectImage}
        selectVideo={selectVideo}
        setSelectedVideo={setSelectedVideo}
        setSelectedImage={setSelectedImage}
        selectedTeam={selectedTeam}
        myToast={myToast}
        hiddenFileInput={hiddenFileInput}
        teamsList={teamsList}
        rolesList={rolesList}
        designationList={designationList}
        showEmployeeModal={showEmployeeModal}
        handleEmployeeClose={handleEmployeeClose}
        refreshEmployeeList={employeeListMutate}
        setSelectedEmployee={setSelectedEmployee}
        role={role}
        employeeNumber={employeeNumber}
        employeesList={employeesList}
        assignees={assignees}
        teamDetails={teamsDetails}
        selectedReportingPerson={selectedReportingPerson}
      />

      {enableSidePanel ? (
        <EmployeeDetailsSidePanel
          selectFilePath={selectFilePath}
          hiddenFileInput={hiddenFileInput}
          myToast={myToast}
          setSelectedFilePath={setSelectedFilePath}
          selectImage={selectImage}
          setSelectedImage={setSelectedImage}
          employeeDataMutate={employeeDataMutate}
          enableEmployeeEdit={enableEmployeeEdit}
          setEnableEmployeeEdit={setEnableEmployeeEdit}
          permissions={permissions}
          isEmpDataLoading={isEmpDataLoading}
          teamsList={teamsList}
          rolesList={rolesList}
          designationList={designationList}
          enableSidePanel={enableSidePanel}
          employeeDetails={employeeDetails}
          setEnableSidePanel={setEnableSidePanel}
          handleSidePanelClose={handleSidePanelClose}
          refreshEmployeeList={employeeListMutate}
          setSelectedEmployee={setSelectedEmployee}
          role={role}
          assignees={assignees}
        />
      ) : (
        ""
      )}
    </>
  );
}

export default Team;
